


  
  

  var faHandshakeSimple = {
    prefix: 'fal',
    iconName: 'handshake-simple',
    icon: [
      640,
      512,
      [129309,"handshake-alt"],
      'f4c6',
      
      'M263.9 64l8.7 0L237.4 99.2c-16.6 4.1-32.2 11.9-45.5 23.1l-40.5 34c-2.9 2.4-6.5 3.8-10.3 3.8L48 160c-8.8 0-16-7.2-16-16s7.2-16 16-16l87.3 0 36-30.3C197.2 76 230 64 263.9 64zm28.4 35c23.8-22.5 55.3-35 88.1-35c30.2 0 59.4 10.6 82.5 30.1L503.3 128l88.7 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-94.5 0c-3.8 0-7.4-1.3-10.3-3.8l-44.8-37.7C425 104 403.1 96 380.4 96c-24.6 0-48.2 9.4-66.1 26.3l-79.4 75c-14.9 14.1-14.6 38 .8 51.6c13.5 12 33.8 11.8 47-.4l76.1-70.2c6.5-6 16.6-5.6 22.6 .9s5.6 16.6-.9 22.6l-8.1 7.5L458 294.8c7 7 12.1 15.2 15.1 24l118.9 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-116.2 0c-2.3 13.8-9.2 27-20.6 37c-15.7 14-36.5 18.8-55.7 14.8c-2.7 8.1-7 15.8-13 22.5c-23 25.9-62 28.6-88.4 7.3c-.8 .7-1.5 1.5-2.3 2.2c-26.4 23.6-66.7 22.5-91.8-2.6l-24.3-24.3-.1-.1-15.4-15.4-28.6-28.6c-7.5-7.5-17.7-11.7-28.3-11.7L48 352c-8.8 0-16-7.2-16-16s7.2-16 16-16l59.4 0c19.1 0 37.4 7.6 50.9 21.1l28.6 28.6 39.9 39.8c13.1 13.1 34 13.6 47.8 1.3c3.2-2.9 5.8-6.2 7.6-9.8c2.4-4.5 6.7-7.6 11.8-8.4s10.1 .9 13.7 4.5l8.1 8.1c13.1 13.1 34.6 12.5 46.9-1.4c5.8-6.5 8.5-14.7 8.1-22.9c-.3-6 2.8-11.6 8-14.6s11.6-2.8 16.6 .5c11.8 7.6 27.6 6.7 38.6-3c13.7-12.2 14.4-33.5 1.4-46.5L348.9 231l-44.5 41c-25.3 23.4-64.2 23.7-90 .8C185 246.7 184.3 201 212.9 174l79.4-75z'
      
    ]
  };

  
    var faHandshakeAlt = faHandshakeSimple;
  

  
  

  var faBuildingColumns = {
    prefix: 'fal',
    iconName: 'building-columns',
    icon: [
      512,
      512,
      ["bank","institution","museum","university"],
      'f19c',
      
      'M263.9 2.1C259-.7 253-.7 248.1 2.1L15.8 133.7C6 139.3 0 149.6 0 160.8C0 178 14 192 31.2 192L256 192l224.8 0c17.2 0 31.2-14 31.2-31.2c0-11.2-6-21.6-15.8-27.1L263.9 2.1zM306.6 160c3.5-7.3 5.4-15.4 5.4-24c0-30.9-25.1-56-56-56s-56 25.1-56 56c0 8.6 1.9 16.7 5.4 24L34.3 160 256 34.4 477.7 160l-171.1 0zM256 112a24 24 0 1 1 0 48 24 24 0 1 1 0-48zM64 352c-8.8 0-16 7.2-16 16s7.2 16 16 16l384 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l0-128-32 0 0 128-80 0 0-128-32 0 0 128-96 0 0-128-32 0 0 128-80 0 0-128-32 0 0 128zM40 416c-8.8 0-16 7.2-16 16s7.2 16 16 16l432 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L40 416zM16 480c-8.8 0-16 7.2-16 16s7.2 16 16 16l480 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 480z'
      
    ]
  };

  
    var faBank = faBuildingColumns;
  
    var faInstitution = faBuildingColumns;
  
    var faMuseum = faBuildingColumns;
  
    var faUniversity = faBuildingColumns;
  

  
  

  var faDollarSign = {
    prefix: 'fal',
    iconName: 'dollar-sign',
    icon: [
      320,
      512,
      [61781,128178,"dollar","usd"],
      '24',
      
      'M176 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 47.5c-6.3 .1-12.6 .3-18.8 .9c-24 2-47.9 7.8-67.4 20.6C37.7 98.1 23.2 118 17.9 146c-3.8 20.3-1.9 38.2 5.7 53.7C31 215 43.1 226.5 57.1 235.4c26.7 17 63.6 26.7 97.2 35.5l1.7 .4c35.7 9.4 67.8 17.9 89.8 31.9c10.6 6.8 17.8 14.2 21.9 22.6c4 8.3 5.8 19 3 33.8c-3.9 20.7-18.4 36.4-42.9 46c-24.9 9.8-59.1 12.6-98 7c-24.4-3.6-61-12.1-91.3-25.2c-8.1-3.5-17.5 .2-21 8.4s.2 17.5 8.4 21c33.6 14.5 73.1 23.5 99.3 27.4c0 0 .1 0 .1 0c6.4 .9 12.7 1.6 18.9 2.1l0 49.5c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48.6c23.2-.7 44.8-4.7 63.4-11.9c32-12.5 56.2-35.7 62.7-69.9c3.8-20.3 1.9-38.2-5.7-53.7c-7.4-15.3-19.6-26.8-33.5-35.6c-26.7-17-63.6-26.7-97.2-35.5l-1.7-.4c-35.7-9.4-67.8-17.9-89.8-31.9c-10.6-6.8-17.8-14.2-21.9-22.6c-4-8.3-5.8-19-3-33.8c3.6-19.3 13.1-31.8 26-40.2c13.4-8.8 31.5-13.7 52.6-15.5c42.3-3.5 91.3 6 124.3 14c8.6 2.1 17.2-3.2 19.3-11.8s-3.2-17.2-11.8-19.3c-21.9-5.3-52.1-11.7-83.8-14.4L176 16z'
      
    ]
  };

  
    var faDollar = faDollarSign;
  
    var faUsd = faDollarSign;
  

  
  

  var faGripDots = {
    prefix: 'fal',
    iconName: 'grip-dots',
    icon: [
      448,
      512,
      [],
      'e410',
      
      'M384 192a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM224 192a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM48 176a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm64 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM384 352a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM208 336a16 16 0 1 0 32 0 16 16 0 1 0 -32 0zm64 0a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zM64 352a16 16 0 1 0 0-32 16 16 0 1 0 0 32zm0-64a48 48 0 1 1 0 96 48 48 0 1 1 0-96z'
      
    ]
  };

  

  
  

  var faMagnifyingGlassPlus = {
    prefix: 'fal',
    iconName: 'magnifying-glass-plus',
    icon: [
      512,
      512,
      ["search-plus"],
      'f00e',
      
      'M208 32a176 176 0 1 1 0 352 176 176 0 1 1 0-352zm0 384c51.7 0 99-18.8 135.3-50L484.7 507.3c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L366 343.3c31.2-36.4 50-83.7 50-135.3C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zM192 304c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80 80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0 0-80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0 80z'
      
    ]
  };

  
    var faSearchPlus = faMagnifyingGlassPlus;
  

  
  

  var faCircleXmark = {
    prefix: 'fal',
    iconName: 'circle-xmark',
    icon: [
      512,
      512,
      [61532,"times-circle","xmark-circle"],
      'f057',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM180.7 180.7c-6.2 6.2-6.2 16.4 0 22.6L233.4 256l-52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L256 278.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L278.6 256l52.7-52.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L256 233.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0z'
      
    ]
  };

  
    var faTimesCircle = faCircleXmark;
  
    var faXmarkCircle = faCircleXmark;
  

  
  

  var faArrowsUpDown = {
    prefix: 'fal',
    iconName: 'arrows-up-down',
    icon: [
      320,
      512,
      ["arrows-v"],
      'f07d',
      
      'M171.3 4.7c-6.1-6.1-15.9-6.3-22.2-.4l-104 96c-6.5 6-6.9 16.1-.9 22.6s16.1 6.9 22.6 .9L144 52.5l0 404.8L75.3 388.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0l96-96c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L176 457.4l0-402.7 68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96z'
      
    ]
  };

  
    var faArrowsV = faArrowsUpDown;
  

  
  

  var faDatabase = {
    prefix: 'fal',
    iconName: 'database',
    icon: [
      448,
      512,
      [],
      'f1c0',
      
      'M416 416c0 2.4-1 7.4-8.4 14.9c-7.5 7.6-19.9 15.9-37.8 23.6C334.1 469.8 282.6 480 224 480s-110.1-10.2-145.8-25.5c-17.9-7.7-30.3-16-37.8-23.6C33 423.4 32 418.4 32 416l0-84.5c17.2 8.9 38.1 16.3 61.2 21.9C130.7 362.7 175.8 368 224 368s93.3-5.3 130.8-14.5c23.1-5.7 44-13 61.2-21.9l0 84.5zm0-212.5l0 90.6c-14.5 10.6-37.9 20.6-68.9 28.3C312.5 330.9 270 336 224 336s-88.5-5.1-123.1-13.6c-31-7.6-54.4-17.7-68.9-28.3l0-90.6c17.2 8.9 38.1 16.3 61.2 21.9C130.7 234.7 175.8 240 224 240s93.3-5.3 130.8-14.5c23.1-5.7 44-13 61.2-21.9zm0-37.4c-14.5 10.6-37.9 20.6-68.9 28.3C312.5 202.9 270 208 224 208s-88.5-5.1-123.1-13.6c-31-7.6-54.4-17.7-68.9-28.3L32 96c0-2.4 1-7.4 8.4-14.9c7.5-7.6 19.9-15.9 37.8-23.6C113.9 42.2 165.4 32 224 32s110.1 10.2 145.8 25.5c17.9 7.7 30.3 16 37.8 23.6C415 88.6 416 93.6 416 96l0 70.1zM448 416l0-320C448 43 347.7 0 224 0S0 43 0 96L0 416c0 53 100.3 96 224 96s224-43 224-96z'
      
    ]
  };

  

  
  

  var faBriefcase = {
    prefix: 'fal',
    iconName: 'briefcase',
    icon: [
      512,
      512,
      [128188],
      'f0b1',
      
      'M160 48l0 48 192 0 0-48c0-8.8-7.2-16-16-16L176 32c-8.8 0-16 7.2-16 16zM128 96l0-48c0-26.5 21.5-48 48-48L336 0c26.5 0 48 21.5 48 48l0 48 64 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 160c0-35.3 28.7-64 64-64l64 0zm240 32l-224 0-80 0c-17.7 0-32 14.3-32 32l0 96 144 0 32 0 96 0 32 0 144 0 0-96c0-17.7-14.3-32-32-32l-80 0zM480 288l-144 0 0 48c0 17.7-14.3 32-32 32l-96 0c-17.7 0-32-14.3-32-32l0-48L32 288l0 128c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-128zm-272 0l0 48 96 0 0-48-96 0z'
      
    ]
  };

  

  
  

  var faAngleLeft = {
    prefix: 'fal',
    iconName: 'angle-left',
    icon: [
      320,
      512,
      [8249],
      'f104',
      
      'M52.7 267.3c-6.2-6.2-6.2-16.4 0-22.6l160-160c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L86.6 256 235.3 404.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-160-160z'
      
    ]
  };

  

  
  

  var faCheck = {
    prefix: 'fal',
    iconName: 'check',
    icon: [
      448,
      512,
      [10003,10004],
      'f00c',
      
      'M443.3 100.7c6.2 6.2 6.2 16.4 0 22.6l-272 272c-6.2 6.2-16.4 6.2-22.6 0l-144-144c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L160 361.4 420.7 100.7c6.2-6.2 16.4-6.2 22.6 0z'
      
    ]
  };

  

  
  

  var faBook = {
    prefix: 'fal',
    iconName: 'book',
    icon: [
      448,
      512,
      [128212],
      'f02d',
      
      'M64 0C28.7 0 0 28.7 0 64L0 448s0 0 0 0c0 35.3 28.7 64 64 64l368 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0 0-66.7c18.6-6.6 32-24.4 32-45.3l0-320c0-26.5-21.5-48-48-48L64 0zM384 416l0 64L64 480c-17.7 0-32-14.3-32-32s14.3-32 32-32l320 0zM64 384c-11.7 0-22.6 3.1-32 8.6L32 64c0-17.7 14.3-32 32-32l32 0 0 352-32 0zm64 0l0-352 272 0c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16l-272 0zm48-240c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16zm0 96c0 8.8 7.2 16 16 16l160 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-160 0c-8.8 0-16 7.2-16 16z'
      
    ]
  };

  

  
  

  var faTableList = {
    prefix: 'fal',
    iconName: 'table-list',
    icon: [
      512,
      512,
      ["th-list"],
      'f00b',
      
      'M192 64l0 96 288 0 0-64c0-17.7-14.3-32-32-32L192 64zm-32 0L64 64C46.3 64 32 78.3 32 96l0 64 128 0 0-96zM32 192l0 128 128 0 0-128L32 192zm0 160l0 64c0 17.7 14.3 32 32 32l96 0 0-96L32 352zm160 96l256 0c17.7 0 32-14.3 32-32l0-64-288 0 0 96zM480 320l0-128-288 0 0 128 288 0zM0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96z'
      
    ]
  };

  
    var faThList = faTableList;
  

  
  

  var faFunction = {
    prefix: 'fal',
    iconName: 'function',
    icon: [
      640,
      512,
      [],
      'f661',
      
      'M80 80c0-44.2 35.8-80 80-80l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-48 0c-26.5 0-48 21.5-48 48l0 112 64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0 0 174.1c0 41.1-31.1 75.5-72 79.6l-22.4 2.2C8.8 480.8 1 474.4 .1 465.6s5.5-16.6 14.3-17.5l22.4-2.2C61.3 443.4 80 422.7 80 398.1L80 224l-64 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0L80 80zm221.5 80.5C272.8 206.1 256 260.9 256 320s16.8 113.9 45.5 159.5c4.7 7.5 2.5 17.4-5 22.1s-17.4 2.5-22.1-5C242.5 445.9 224 385.2 224 320s18.5-125.9 50.5-176.5c4.7-7.5 14.6-9.7 22.1-5s9.7 14.6 5 22.1zm260.9 0c-4.7-7.5-2.5-17.4 5-22.1s17.4-2.5 22.1 5C621.5 194.1 640 254.8 640 320s-18.5 125.9-50.5 176.5c-4.7 7.5-14.6 9.7-22.1 5s-9.7-14.6-5-22.1C591.2 433.9 608 379.1 608 320s-16.8-113.9-45.5-159.5zM379.3 244.7L432 297.4l52.7-52.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L454.6 320l52.7 52.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 342.6l-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L409.4 320l-52.7-52.7c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0z'
      
    ]
  };

  

  
  

  var faBorderAll = {
    prefix: 'fal',
    iconName: 'border-all',
    icon: [
      448,
      512,
      [],
      'f84c',
      
      'M384 64c17.7 0 32 14.3 32 32l0 144-176 0 0-176 144 0zm32 208l0 144c0 17.7-14.3 32-32 32l-144 0 0-176 176 0zM208 240L32 240 32 96c0-17.7 14.3-32 32-32l144 0 0 176zM32 272l176 0 0 176L64 448c-17.7 0-32-14.3-32-32l0-144zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z'
      
    ]
  };

  

  
  

  var faClone = {
    prefix: 'fal',
    iconName: 'clone',
    icon: [
      512,
      512,
      [],
      'f24d',
      
      'M64 480l224 0c17.7 0 32-14.3 32-32l0-64 32 0 0 64c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 224c0-35.3 28.7-64 64-64l64 0 0 32-64 0c-17.7 0-32 14.3-32 32l0 224c0 17.7 14.3 32 32 32zM224 320l224 0c17.7 0 32-14.3 32-32l0-224c0-17.7-14.3-32-32-32L224 32c-17.7 0-32 14.3-32 32l0 224c0 17.7 14.3 32 32 32zm-64-32l0-224c0-35.3 28.7-64 64-64L448 0c35.3 0 64 28.7 64 64l0 224c0 35.3-28.7 64-64 64l-224 0c-35.3 0-64-28.7-64-64z'
      
    ]
  };

  

  
  

  var faCirclePlus = {
    prefix: 'fal',
    iconName: 'circle-plus',
    icon: [
      512,
      512,
      ["plus-circle"],
      'f055',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM240 352c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80 80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0 0-80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0 80z'
      
    ]
  };

  
    var faPlusCircle = faCirclePlus;
  

  
  

  var faCalendar = {
    prefix: 'fal',
    iconName: 'calendar',
    icon: [
      448,
      512,
      [128197,128198],
      'f133',
      
      'M112 0c8.8 0 16 7.2 16 16l0 48 192 0 0-48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 48 32 0c35.3 0 64 28.7 64 64l0 32 0 32 0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192l0-32 0-32C0 92.7 28.7 64 64 64l32 0 0-48c0-8.8 7.2-16 16-16zM416 192L32 192l0 256c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-256zM384 96L64 96c-17.7 0-32 14.3-32 32l0 32 384 0 0-32c0-17.7-14.3-32-32-32z'
      
    ]
  };

  

  
  

  var faUpRightAndDownLeftFromCenter = {
    prefix: 'fal',
    iconName: 'up-right-and-down-left-from-center',
    icon: [
      512,
      512,
      ["expand-alt"],
      'f424',
      
      'M321 0c-18.2 0-33 14.8-33 33c0 8.7 3.5 17.1 9.7 23.3L325.4 84l-71.7 71.7c-15.6 15.6-15.6 40.9 0 56.6l46.1 46.1c15.6 15.6 40.9 15.6 56.6 0L428 186.6l27.7 27.7c6.2 6.2 14.6 9.7 23.3 9.7c18.2 0 33-14.8 33-33l0-159c0-17.7-14.3-32-32-32L321 0zm-1 33c0-.5 .4-1 1-1l159 0 0 159c0 .5-.4 1-1 1c-.3 0-.5-.1-.7-.3l-39-39c-6.2-6.2-16.4-6.2-22.6 0l-83 83c-3.1 3.1-8.2 3.1-11.3 0l-46.1-46.1c-3.1-3.1-3.1-8.2 0-11.3l83-83c3-3 4.7-7.1 4.7-11.3s-1.7-8.3-4.7-11.3l-39-39c-.2-.2-.3-.4-.3-.7zM32 512l159 0c18.2 0 33-14.8 33-33c0-8.7-3.5-17.1-9.7-23.3L186.6 428l71.7-71.7c15.6-15.6 15.6-40.9 0-56.6l-46.1-46.1c-15.6-15.6-40.9-15.6-56.6 0L84 325.4 56.3 297.7C50.1 291.5 41.7 288 33 288c-18.2 0-33 14.8-33 33L0 480c0 17.7 14.3 32 32 32zm160-33c0 .5-.4 1-1 1L32 480l0-159c0-.5 .4-1 1-1c.3 0 .5 .1 .7 .3l39 39c6.2 6.2 16.4 6.2 22.6 0l83-83c3.1-3.1 8.2-3.1 11.3 0l46.1 46.1c3.1 3.1 3.1 8.2 0 11.3l-83 83c-3 3-4.7 7.1-4.7 11.3s1.7 8.3 4.7 11.3l39 39c.2 .2 .3 .4 .3 .7z'
      
    ]
  };

  
    var faExpandAlt = faUpRightAndDownLeftFromCenter;
  

  
  

  var faHashtag = {
    prefix: 'fal',
    iconName: 'hashtag',
    icon: [
      448,
      512,
      [62098],
      '23',
      
      'M207.6 51.6c2-8.6-3.4-17.2-12-19.2s-17.2 3.4-19.2 12l-23 99.6L48 144c-8.8 0-16 7.2-16 16s7.2 16 16 16l98 0L109.1 336 16 336c-8.8 0-16 7.2-16 16s7.2 16 16 16l85.7 0L80.4 460.4c-2 8.6 3.4 17.2 12 19.2s17.2-3.4 19.2-12l23-99.6 127.2 0-21.3 92.4c-2 8.6 3.4 17.2 12 19.2s17.2-3.4 19.2-12l23-99.6L400 368c8.8 0 16-7.2 16-16s-7.2-16-16-16l-98 0 36.9-160 93.1 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-85.7 0 21.3-92.4c2-8.6-3.4-17.2-12-19.2s-17.2 3.4-19.2 12l-23 99.6-127.2 0 21.3-92.4zM178.9 176L306 176 269.1 336 142 336l36.9-160z'
      
    ]
  };

  

  
  

  var faClockRotateLeft = {
    prefix: 'fal',
    iconName: 'clock-rotate-left',
    icon: [
      512,
      512,
      ["history"],
      'f1da',
      
      'M32 132l0-84c0-8.8-7.2-16-16-16S0 39.2 0 48L0 176c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-90.4 0C89.5 84.3 166.7 32 256 32c123.7 0 224 100.3 224 224s-100.3 224-224 224c-73.3 0-138.3-35.2-179.2-89.6c-5.3-7.1-15.3-8.5-22.4-3.2s-8.5 15.3-3.2 22.4C97.9 471.8 172.2 512 256 512c141.4 0 256-114.6 256-256S397.4 0 256 0C159.6 0 75.7 53.3 32 132zm224-4c-8.8 0-16 7.2-16 16l0 112c0 4.2 1.7 8.3 4.7 11.3l80 80c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L272 249.4 272 144c0-8.8-7.2-16-16-16z'
      
    ]
  };

  
    var faHistory = faClockRotateLeft;
  

  
  

  var faAnglesLeft = {
    prefix: 'fal',
    iconName: 'angles-left',
    icon: [
      512,
      512,
      [171,"angle-double-left"],
      'f100',
      
      'M68.1 245.3c-5.5 6.1-5.5 15.3 0 21.4l144 160c5.9 6.6 16 7.1 22.6 1.2s7.1-16 1.2-22.6L101.5 256 235.9 106.7c5.9-6.6 5.4-16.7-1.2-22.6s-16.7-5.4-22.6 1.2l-144 160zm336-160l-144 160c-5.5 6.1-5.5 15.3 0 21.4l144 160c5.9 6.6 16 7.1 22.6 1.2s7.1-16 1.2-22.6L293.5 256 427.9 106.7c5.9-6.6 5.4-16.7-1.2-22.6s-16.7-5.4-22.6 1.2z'
      
    ]
  };

  
    var faAngleDoubleLeft = faAnglesLeft;
  

  
  

  var faArrowRightToLine = {
    prefix: 'fal',
    iconName: 'arrow-right-to-line',
    icon: [
      448,
      512,
      [8677,"arrow-to-right"],
      'f340',
      
      'M448 80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 352c0 8.8 7.2 16 16 16s16-7.2 16-16l0-352zM347.3 267.3c6.2-6.2 6.2-16.4 0-22.6l-128-128c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L297.4 240 192 240 16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l176 0 105.4 0L196.7 372.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l128-128z'
      
    ]
  };

  
    var faArrowToRight = faArrowRightToLine;
  

  
  

  var faPercent = {
    prefix: 'fal',
    iconName: 'percent',
    icon: [
      384,
      512,
      [62101,62785,"percentage"],
      '25',
      
      'M64 96a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96A64 64 0 1 0 64 64a64 64 0 1 0 0 128zM320 352a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm0 96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM379.3 91.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-352 352c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l352-352z'
      
    ]
  };

  
    var faPercentage = faPercent;
  

  
  

  var faChevronRight = {
    prefix: 'fal',
    iconName: 'chevron-right',
    icon: [
      320,
      512,
      [9002],
      'f054',
      
      'M299.3 244.7c6.2 6.2 6.2 16.4 0 22.6l-192 192c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L265.4 256 84.7 75.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l192 192z'
      
    ]
  };

  

  
  

  var faChevronLeft = {
    prefix: 'fal',
    iconName: 'chevron-left',
    icon: [
      320,
      512,
      [9001],
      'f053',
      
      'M20.7 267.3c-6.2-6.2-6.2-16.4 0-22.6l192-192c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6L54.6 256 235.3 436.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0l-192-192z'
      
    ]
  };

  

  
  

  var faAngleUp = {
    prefix: 'fal',
    iconName: 'angle-up',
    icon: [
      448,
      512,
      [8963],
      'f106',
      
      'M212.7 148.7c6.2-6.2 16.4-6.2 22.6 0l160 160c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L224 182.6 75.3 331.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l160-160z'
      
    ]
  };

  

  
  

  var faXmark = {
    prefix: 'fal',
    iconName: 'xmark',
    icon: [
      384,
      512,
      [215,10005,10006,10060,128473,"close","multiply","remove","times"],
      'f00d',
      
      'M324.5 411.1c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L214.6 256 347.1 123.5c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L192 233.4 59.6 100.9c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L169.4 256 36.9 388.5c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L192 278.6 324.5 411.1z'
      
    ]
  };

  
    var faClose = faXmark;
  
    var faMultiply = faXmark;
  
    var faRemove = faXmark;
  
    var faTimes = faXmark;
  

  
  

  var faPlus = {
    prefix: 'fal',
    iconName: 'plus',
    icon: [
      448,
      512,
      [10133,61543,"add"],
      '2b',
      
      'M240 64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 176L32 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l176 0 0 176c0 8.8 7.2 16 16 16s16-7.2 16-16l0-176 176 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-176 0 0-176z'
      
    ]
  };

  
    var faAdd = faPlus;
  

  
  

  var faDiagramProject = {
    prefix: 'fal',
    iconName: 'diagram-project',
    icon: [
      576,
      512,
      ["project-diagram"],
      'f542',
      
      'M136 64c13.3 0 24 10.7 24 24l0 24 0 32 0 24c0 13.3-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24l80 0zm56 104l0-24 192 0 0 24c0 30.9 25.1 56 56 56l80 0c30.9 0 56-25.1 56-56l0-80c0-30.9-25.1-56-56-56l-80 0c-30.9 0-56 25.1-56 56l0 24-192 0 0-24c0-30.9-25.1-56-56-56L56 32C25.1 32 0 57.1 0 88l0 80c0 30.9 25.1 56 56 56l80 0c8.6 0 16.7-1.9 24-5.4l72.2 96.3c-5.2 8.5-8.2 18.5-8.2 29.1l0 80c0 30.9 25.1 56 56 56l80 0c30.9 0 56-25.1 56-56l0-80c0-30.9-25.1-56-56-56l-80 0c-8.6 0-16.7 1.9-24 5.4l-72.2-96.3c5.2-8.5 8.2-18.5 8.2-29.1zm224 0l0-24 0-32 0-24c0-13.3 10.7-24 24-24l80 0c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24zM360 320c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24l80 0z'
      
    ]
  };

  
    var faProjectDiagram = faDiagramProject;
  

  
  

  var faListCheck = {
    prefix: 'fal',
    iconName: 'list-check',
    icon: [
      512,
      512,
      ["tasks"],
      'f0ae',
      
      'M156.3 58.2c5.7-6.8 4.7-16.9-2-22.5s-16.9-4.7-22.5 2L62.9 120.3 27.3 84.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l48 48c3.2 3.2 7.5 4.9 12 4.7s8.7-2.3 11.6-5.7l80-96zm0 160c5.7-6.8 4.7-16.9-2-22.5s-16.9-4.7-22.5 2L62.9 280.3 27.3 244.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l48 48c3.2 3.2 7.5 4.9 12 4.7s8.7-2.3 11.6-5.7l80-96zM192 96c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L208 80c-8.8 0-16 7.2-16 16zm0 160c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-288 0c-8.8 0-16 7.2-16 16zM160 416c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-320 0c-8.8 0-16 7.2-16 16zm-64 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  
    var faTasks = faListCheck;
  

  
  

  var faListUl = {
    prefix: 'fal',
    iconName: 'list-ul',
    icon: [
      512,
      512,
      ["list-dots"],
      'f0ca',
      
      'M64 64a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM176 80c-8.8 0-16 7.2-16 16s7.2 16 16 16l320 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L176 80zm0 160c-8.8 0-16 7.2-16 16s7.2 16 16 16l320 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-320 0zm0 160c-8.8 0-16 7.2-16 16s7.2 16 16 16l320 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-320 0zM96 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM64 384a32 32 0 1 0 0 64 32 32 0 1 0 0-64z'
      
    ]
  };

  
    var faListDots = faListUl;
  

  
  

  var faSignalGood = {
    prefix: 'fal',
    iconName: 'signal-good',
    icon: [
      640,
      512,
      ["signal-3"],
      'f68e',
      
      'M336 208c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16s16-7.2 16-16l0-288zM192 288c-8.8 0-16 7.2-16 16l0 192c0 8.8 7.2 16 16 16s16-7.2 16-16l0-192c0-8.8-7.2-16-16-16zM64 384c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-8.8-7.2-16-16-16z'
      
    ]
  };

  
    var faSignal3 = faSignalGood;
  

  
  

  var faMagnifyingGlass = {
    prefix: 'fal',
    iconName: 'magnifying-glass',
    icon: [
      512,
      512,
      [128269,"search"],
      'f002',
      
      'M384 208A176 176 0 1 0 32 208a176 176 0 1 0 352 0zM343.3 366C307 397.2 259.7 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 51.7-18.8 99-50 135.3L507.3 484.7c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L343.3 366z'
      
    ]
  };

  
    var faSearch = faMagnifyingGlass;
  

  
  

  var faFont = {
    prefix: 'fal',
    iconName: 'font',
    icon: [
      448,
      512,
      [],
      'f031',
      
      'M238.7 41.8c-2.5-5.9-8.3-9.8-14.7-9.8s-12.2 3.8-14.7 9.8L37.4 448 16 448c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-23.9 0 40.6-96 222.5 0 40.6 96L352 448c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-21.4 0L238.7 41.8zm83 278.2l-195.4 0L224 89.1 321.7 320z'
      
    ]
  };

  

  
  

  var faLink = {
    prefix: 'fal',
    iconName: 'link',
    icon: [
      640,
      512,
      [128279,"chain"],
      'f0c1',
      
      'M591.5 256c50-50 50-131 0-181s-131-50-181 0L387.9 97.6c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l22.6-22.6c37.5-37.5 98.3-37.5 135.8 0s37.5 98.3 0 135.8L444.3 357.9c-37.4 37.4-98.1 37.4-135.6 0c-35.6-35.6-37.6-92.6-4.7-130.6l5.3-6.1c5.8-6.7 5.1-16.8-1.6-22.6s-16.8-5.1-22.6 1.6l-5.3 6.1c-43.9 50.7-41.2 126.7 6.2 174.1c49.9 49.9 130.9 49.9 180.8 0L591.5 256zM48.5 256c-50 50-50 131 0 181s131 50 181 0l22.6-22.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-22.6 22.6c-37.5 37.5-98.3 37.5-135.8 0s-37.5-98.3 0-135.8L195.7 154.1c37.4-37.4 98.1-37.4 135.6 0c35.6 35.6 37.6 92.6 4.7 130.6l-5.3 6.1c-5.8 6.7-5.1 16.8 1.6 22.6s16.8 5.1 22.6-1.6l5.3-6.1c43.9-50.7 41.2-126.7-6.2-174.1C303.9 81.5 223 81.5 173 131.4L48.5 256z'
      
    ]
  };

  
    var faChain = faLink;
  

  
  

  var faBarsStaggered = {
    prefix: 'fal',
    iconName: 'bars-staggered',
    icon: [
      512,
      512,
      ["reorder","stream"],
      'f550',
      
      'M0 80c0-8.8 7.2-16 16-16l416 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 96C7.2 96 0 88.8 0 80zM64 240c0-8.8 7.2-16 16-16l416 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 256c-8.8 0-16-7.2-16-16zM448 400c0 8.8-7.2 16-16 16L16 416c-8.8 0-16-7.2-16-16s7.2-16 16-16l416 0c8.8 0 16 7.2 16 16z'
      
    ]
  };

  
    var faReorder = faBarsStaggered;
  
    var faStream = faBarsStaggered;
  

  
  

  var faFile = {
    prefix: 'fal',
    iconName: 'file',
    icon: [
      384,
      512,
      [61462,128196,128459],
      'f15b',
      
      'M352 448l0-256-112 0c-26.5 0-48-21.5-48-48l0-112L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32zm-.5-288c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2L224 144c0 8.8 7.2 16 16 16l111.5 0zM0 64C0 28.7 28.7 0 64 0L220.1 0c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64z'
      
    ]
  };

  

  
  

  var faBell = {
    prefix: 'fal',
    iconName: 'bell',
    icon: [
      448,
      512,
      [61602,128276],
      'f0f3',
      
      'M208 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 16.8c80.9 8 144 76.2 144 159.2l0 29.1c0 43.7 17.4 85.6 48.3 116.6l2.8 2.8c8.3 8.3 13 19.6 13 31.3c0 24.5-19.8 44.3-44.3 44.3L44.3 416C19.8 416 0 396.2 0 371.7c0-11.7 4.7-23 13-31.3l2.8-2.8C46.6 306.7 64 264.8 64 221.1L64 192c0-83 63.1-151.2 144-159.2L208 16zm16 48C153.3 64 96 121.3 96 192l0 29.1c0 52.2-20.7 102.3-57.7 139.2L35.6 363c-2.3 2.3-3.6 5.4-3.6 8.7c0 6.8 5.5 12.3 12.3 12.3l359.4 0c6.8 0 12.3-5.5 12.3-12.3c0-3.3-1.3-6.4-3.6-8.7l-2.8-2.8c-36.9-36.9-57.7-87-57.7-139.2l0-29.1c0-70.7-57.3-128-128-128zM193.8 458.7c4.4 12.4 16.3 21.3 30.2 21.3s25.8-8.9 30.2-21.3c2.9-8.3 12.1-12.7 20.4-9.8s12.7 12.1 9.8 20.4C275.6 494.2 251.9 512 224 512s-51.6-17.8-60.4-42.7c-2.9-8.3 1.4-17.5 9.8-20.4s17.5 1.4 20.4 9.8z'
      
    ]
  };

  

  
  

  var faMessageDots = {
    prefix: 'fal',
    iconName: 'message-dots',
    icon: [
      512,
      512,
      ["comment-alt-dots","messaging"],
      'f4a3',
      
      'M192 416c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32l0 288c0 17.7-14.3 32-32 32l-138.7 0c-6.9 0-13.7 2.2-19.2 6.4L192 464l0-48zM64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l64 0 32 0 0 32 0 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416 448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0zm64 232a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm128 0a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm152-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  
    var faCommentAltDots = faMessageDots;
  
    var faMessaging = faMessageDots;
  

  
  

  var faEllipsis = {
    prefix: 'fal',
    iconName: 'ellipsis',
    icon: [
      448,
      512,
      ["ellipsis-h"],
      'f141',
      
      'M416 256a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm-160 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zM64 288a32 32 0 1 1 0-64 32 32 0 1 1 0 64z'
      
    ]
  };

  
    var faEllipsisH = faEllipsis;
  

  
  

  var faGripLines = {
    prefix: 'fal',
    iconName: 'grip-lines',
    icon: [
      448,
      512,
      [],
      'f7a4',
      
      'M448 192c0-8.8-7.2-16-16-16L16 176c-8.8 0-16 7.2-16 16s7.2 16 16 16l416 0c8.8 0 16-7.2 16-16zm0 128c0-8.8-7.2-16-16-16L16 304c-8.8 0-16 7.2-16 16s7.2 16 16 16l416 0c8.8 0 16-7.2 16-16z'
      
    ]
  };

  

  
  

  var faAngleDown = {
    prefix: 'fal',
    iconName: 'angle-down',
    icon: [
      448,
      512,
      [8964],
      'f107',
      
      'M212.7 363.3c6.2 6.2 16.4 6.2 22.6 0l160-160c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 329.4 75.3 180.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l160 160z'
      
    ]
  };

  

  
  

  var faChartMixed = {
    prefix: 'fal',
    iconName: 'chart-mixed',
    icon: [
      512,
      512,
      ["analytics"],
      'f643',
      
      'M507.8 37.2c5.9 6.5 5.5 16.7-1.1 22.6l-176 160c-6.3 5.7-16 5.5-22.1-.5L190.4 101 25.4 220.9c-7.1 5.2-17.2 3.6-22.4-3.5s-3.6-17.2 3.5-22.4l176-128c6.4-4.6 15.2-3.9 20.7 1.6L320.5 185.9 485.2 36.2c6.5-5.9 16.7-5.5 22.6 1.1zM80 432l0-64c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 64c0 8.8 7.2 16 16 16s16-7.2 16-16zM64 320c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-64c0-26.5 21.5-48 48-48zm144-48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160zm-64 0c0-26.5 21.5-48 48-48s48 21.5 48 48l0 160c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-160zM336 432l0-96c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16zM320 288c26.5 0 48 21.5 48 48l0 96c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-96c0-26.5 21.5-48 48-48zm144-16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 160c0 8.8 7.2 16 16 16s16-7.2 16-16l0-160zm-64 0c0-26.5 21.5-48 48-48s48 21.5 48 48l0 160c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-160z'
      
    ]
  };

  
    var faAnalytics = faChartMixed;
  

  
  

  var faFileArrowDown = {
    prefix: 'fal',
    iconName: 'file-arrow-down',
    icon: [
      384,
      512,
      ["file-download"],
      'f56d',
      
      'M320 480L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l128 0 0 112c0 26.5 21.5 48 48 48l112 0 0 256c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16l0-111.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4L240 160zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-284.1c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1L64 0zM208 240c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 121.4-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l80 80c6.2 6.2 16.4 6.2 22.6 0l80-80c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L208 361.4 208 240z'
      
    ]
  };

  
    var faFileDownload = faFileArrowDown;
  

  
  

  var faUpload = {
    prefix: 'fal',
    iconName: 'upload',
    icon: [
      512,
      512,
      [],
      'f093',
      
      'M272 54.6L272 368c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-313.4L139.3 155.3c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l128-128c6.2-6.2 16.4-6.2 22.6 0l128 128c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L272 54.6zM208 352L64 352c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-144 0 0-32 144 0c35.3 0 64 28.7 64 64l0 64c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64l0-64c0-35.3 28.7-64 64-64l144 0 0 32zm176 64a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  

  
  

  var faArrowUpWideShort = {
    prefix: 'fal',
    iconName: 'arrow-up-wide-short',
    icon: [
      576,
      512,
      ["sort-amount-up"],
      'f161',
      
      'M139.3 36.7c-6.2-6.2-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L112 86.6 112 464c0 8.8 7.2 16 16 16s16-7.2 16-16l0-377.4 68.7 68.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-96-96zM304 464l64 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-64 0c-8.8 0-16 7.2-16 16s7.2 16 16 16zm0-128l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16s7.2 16 16 16zm0-128l192 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-192 0c-8.8 0-16 7.2-16 16s7.2 16 16 16zm0-128l256 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L304 48c-8.8 0-16 7.2-16 16s7.2 16 16 16z'
      
    ]
  };

  
    var faSortAmountUp = faArrowUpWideShort;
  

  
  

  var faArrowRightArrowLeft = {
    prefix: 'fal',
    iconName: 'arrow-right-arrow-left',
    icon: [
      448,
      512,
      [8644,"exchange"],
      'f0ec',
      
      'M443.3 139.3c6.2-6.2 6.2-16.4 0-22.6l-96-96c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L393.4 112 16 112c-8.8 0-16 7.2-16 16s7.2 16 16 16l377.4 0-68.7 68.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96zm-342.6 352c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L54.6 400 432 400c8.8 0 16-7.2 16-16s-7.2-16-16-16L54.6 368l68.7-68.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6l96 96z'
      
    ]
  };

  
    var faExchange = faArrowRightArrowLeft;
  

  
  

  var faHouse = {
    prefix: 'fal',
    iconName: 'house',
    icon: [
      576,
      512,
      [63498,63500,127968,"home","home-alt","home-lg-alt"],
      'f015',
      
      'M298.6 4c-6-5.3-15.1-5.3-21.2 0L5.4 244c-6.6 5.8-7.3 16-1.4 22.6s16 7.3 22.6 1.4L64 235l0 197c0 44.2 35.8 80 80 80l288 0c44.2 0 80-35.8 80-80l0-197 37.4 33c6.6 5.8 16.7 5.2 22.6-1.4s5.2-16.7-1.4-22.6L298.6 4zM96 432l0-225.3L288 37.3 480 206.7 480 432c0 26.5-21.5 48-48 48l-64 0 0-160c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32 14.3-32 32l0 160-64 0c-26.5 0-48-21.5-48-48zm144 48l0-160 96 0 0 160-96 0z'
      
    ]
  };

  
    var faHome = faHouse;
  
    var faHomeAlt = faHouse;
  
    var faHomeLgAlt = faHouse;
  

  
  

  var faDownload = {
    prefix: 'fal',
    iconName: 'download',
    icon: [
      512,
      512,
      [],
      'f019',
      
      'M272 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 313.4L139.3 228.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l128 128c6.2 6.2 16.4 6.2 22.6 0l128-128c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L272 329.4 272 16zM140.1 320L64 320c-35.3 0-64 28.7-64 64l0 64c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-64c0-35.3-28.7-64-64-64l-76.1 0-32 32L448 352c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32l0-64c0-17.7 14.3-32 32-32l108.1 0-32-32zM432 416a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  

  
  

  var faEllipsisVertical = {
    prefix: 'fal',
    iconName: 'ellipsis-vertical',
    icon: [
      128,
      512,
      ["ellipsis-v"],
      'f142',
      
      'M64 384a32 32 0 1 0 0 64 32 32 0 1 0 0-64zm0-160a32 32 0 1 0 0 64 32 32 0 1 0 0-64zM96 96A32 32 0 1 0 32 96a32 32 0 1 0 64 0z'
      
    ]
  };

  
    var faEllipsisV = faEllipsisVertical;
  

  
  

  var faFlask = {
    prefix: 'fal',
    iconName: 'flask',
    icon: [
      448,
      512,
      [],
      'f0c3',
      
      'M288 196.8L288 32 160 32l0 164.8c0 17.8-4.9 35.2-14.2 50.3L100.9 320l246.2 0-44.8-72.9C292.9 232 288 214.6 288 196.8zM128 32l-16 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l48 0L288 0l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-16 0 0 164.8c0 11.8 3.3 23.5 9.5 33.5L437.7 406.2c6.7 10.9 10.3 23.5 10.3 36.4c0 38.3-31.1 69.4-69.4 69.4L69.4 512C31.1 512 0 480.9 0 442.6c0-12.8 3.6-25.4 10.3-36.4L118.5 230.4c6.2-10.1 9.5-21.7 9.5-33.5L128 32zM37.5 423c-3.6 5.9-5.5 12.7-5.5 19.6C32 463.3 48.7 480 69.4 480l309.2 0c20.7 0 37.4-16.7 37.4-37.4c0-6.9-1.9-13.7-5.5-19.6l-43.7-71L81.2 352 37.5 423z'
      
    ]
  };

  

  
  

  var faSliders = {
    prefix: 'fal',
    iconName: 'sliders',
    icon: [
      512,
      512,
      ["sliders-h"],
      'f1de',
      
      'M0 416c0 8.8 7.2 16 16 16l65.6 0c7.4 36.5 39.7 64 78.4 64s71-27.5 78.4-64L496 432c8.8 0 16-7.2 16-16s-7.2-16-16-16l-257.6 0c-7.4-36.5-39.7-64-78.4-64s-71 27.5-78.4 64L16 400c-8.8 0-16 7.2-16 16zm112 0a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM304 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm48-80c-38.7 0-71 27.5-78.4 64L16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l257.6 0c7.4 36.5 39.7 64 78.4 64s71-27.5 78.4-64l65.6 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-65.6 0c-7.4-36.5-39.7-64-78.4-64zM192 144a48 48 0 1 1 0-96 48 48 0 1 1 0 96zm78.4-64C263 43.5 230.7 16 192 16s-71 27.5-78.4 64L16 80C7.2 80 0 87.2 0 96s7.2 16 16 16l97.6 0c7.4 36.5 39.7 64 78.4 64s71-27.5 78.4-64L496 112c8.8 0 16-7.2 16-16s-7.2-16-16-16L270.4 80z'
      
    ]
  };

  
    var faSlidersH = faSliders;
  

  
  

  var faBallot = {
    prefix: 'fal',
    iconName: 'ballot',
    icon: [
      448,
      512,
      [],
      'f732',
      
      'M384 32c17.7 0 32 14.3 32 32l0 384c0 17.7-14.3 32-32 32L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l320 0zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-384c0-35.3-28.7-64-64-64L64 0zm96 128c0 8.8 7.2 16 16 16l176 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-176 0c-8.8 0-16 7.2-16 16zm0 128c0 8.8 7.2 16 16 16l176 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-176 0c-8.8 0-16 7.2-16 16zm0 128c0 8.8 7.2 16 16 16l176 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-176 0c-8.8 0-16 7.2-16 16zM88 104c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0zM72 248l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0c-8.8 0-16 7.2-16 16zM88 360c-8.8 0-16 7.2-16 16l0 16c0 8.8 7.2 16 16 16l16 0c8.8 0 16-7.2 16-16l0-16c0-8.8-7.2-16-16-16l-16 0z'
      
    ]
  };

  

  
  

  var faClock = {
    prefix: 'fal',
    iconName: 'clock',
    icon: [
      512,
      512,
      [128339,"clock-four"],
      'f017',
      
      'M480 256A224 224 0 1 1 32 256a224 224 0 1 1 448 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM240 112l0 144c0 5.3 2.7 10.3 7.1 13.3l96 64c7.4 4.9 17.3 2.9 22.2-4.4s2.9-17.3-4.4-22.2L272 247.4 272 112c0-8.8-7.2-16-16-16s-16 7.2-16 16z'
      
    ]
  };

  
    var faClockFour = faClock;
  

  
  

  var faArrowDownArrowUp = {
    prefix: 'fal',
    iconName: 'arrow-down-arrow-up',
    icon: [
      576,
      512,
      ["sort-alt"],
      'f883',
      
      'M171.3 475.3c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L144 425.4 144 48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 377.4 68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-96 96zm352-342.6c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L432 86.6 432 464c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-377.4-68.7 68.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l96-96c6.2-6.2 16.4-6.2 22.6 0l96 96z'
      
    ]
  };

  
    var faSortAlt = faArrowDownArrowUp;
  

  
  

  var faGear = {
    prefix: 'fal',
    iconName: 'gear',
    icon: [
      512,
      512,
      [9881,"cog"],
      'f013',
      
      'M223.3 37.8c.4-1.5 1.3-2.8 2.4-3.8c9.9-1.3 20-2 30.3-2s20.4 .7 30.3 2c1.1 1 1.9 2.3 2.4 3.8l13.7 47.7c3.5 12.1 12.2 21.1 22.5 26.1c7.6 3.6 14.8 7.8 21.7 12.5c9.4 6.5 21.7 9.5 33.9 6.5l48.2-12c1.5-.4 3-.3 4.4 .2c5.4 6.9 10.4 14.2 14.9 21.8l4.3 7.4c4.2 7.5 7.9 15.3 11.2 23.3c-.3 1.5-1 2.9-2.1 4L426.8 211c-8.7 9-12.2 21.1-11.3 32.5c.3 4.1 .5 8.3 .5 12.5s-.2 8.4-.5 12.5c-.9 11.4 2.6 23.5 11.3 32.5l34.5 35.7c1.1 1.1 1.8 2.5 2.1 4c-3.3 8-7 15.8-11.2 23.4l-4.2 7.3c-4.6 7.6-9.6 14.8-14.9 21.8c-1.4 .5-2.9 .5-4.4 .2l-48.2-12c-12.2-3-24.4 0-33.9 6.5c-6.9 4.7-14.1 8.9-21.7 12.5c-10.3 4.9-19.1 14-22.5 26.1l-13.7 47.7c-.4 1.5-1.3 2.8-2.4 3.8c-9.9 1.3-20 2-30.3 2s-20.4-.7-30.3-2c-1.1-1-1.9-2.3-2.4-3.8l-13.7-47.7c-3.5-12.1-12.2-21.1-22.5-26.1c-7.6-3.6-14.8-7.8-21.7-12.5c-9.4-6.5-21.7-9.5-33.9-6.5l-48.2 12c-1.5 .4-3 .3-4.4-.2c-5.4-7-10.4-14.2-15-21.8l-4.2-7.3c-4.2-7.5-7.9-15.3-11.2-23.4c.3-1.5 1-2.9 2.1-4L85.2 301c8.7-9 12.2-21.1 11.3-32.5c-.3-4.1-.5-8.3-.5-12.5s.2-8.4 .5-12.5c.9-11.4-2.6-23.5-11.3-32.5L50.7 175.2c-1.1-1.1-1.8-2.5-2.1-4c3.3-8 7-15.8 11.2-23.4l4.2-7.3c4.6-7.6 9.6-14.8 15-21.8c1.4-.5 2.9-.5 4.4-.2l48.2 12c12.2 3 24.4 0 33.9-6.5c6.9-4.7 14.1-8.9 21.7-12.5c10.3-4.9 19.1-14 22.5-26.1l13.7-47.7zM256 0c-13 0-25.9 1-38.4 2.9c-1.7 .3-3.4 .8-5 1.6c-9.5 4.9-16.9 13.6-20 24.5L178.9 76.7c-.6 2.2-2.5 4.5-5.6 6c-9.1 4.3-17.8 9.4-26 15c-2.8 1.9-5.8 2.4-8 1.8l-48.2-12C80.2 84.8 69 86.9 60 92.6c-1.5 .9-2.8 2.1-3.9 3.5C49 105 42.4 114.3 36.5 124.1l-.1 .3L32 132l-.1 .3c-5.4 9.8-10.2 19.9-14.3 30.4c-.6 1.6-1 3.3-1.1 5c-.5 10.8 3.3 21.6 11.2 29.8l34.5 35.7c1.6 1.7 2.7 4.4 2.4 7.8c-.4 5-.6 10-.6 15s.2 10.1 .6 15c.3 3.4-.8 6.2-2.4 7.8L27.7 314.6c-7.9 8.2-11.7 19-11.2 29.8c.1 1.7 .5 3.4 1.1 5c4.1 10.5 8.9 20.6 14.3 30.4l.1 .3 4.4 7.6 .1 .3c5.9 9.8 12.4 19.2 19.6 28.1c1.1 1.4 2.4 2.6 3.9 3.5c9 5.7 20.2 7.8 31.1 5.1l48.2-12c2.2-.6 5.2-.1 8 1.8c8.2 5.7 16.9 10.7 26 15c3.1 1.5 4.9 3.8 5.6 6L192.6 483c3.1 10.8 10.5 19.5 20 24.5c1.6 .8 3.2 1.4 5 1.6C230.1 511 243 512 256 512s25.9-1 38.4-2.9c1.7-.3 3.4-.8 5-1.6c9.5-4.9 16.9-13.6 20-24.5l13.7-47.7c.6-2.2 2.5-4.5 5.6-6c9.1-4.3 17.8-9.4 26-15c2.8-1.9 5.8-2.4 8-1.8l48.2 12c10.9 2.7 22.1 .7 31.1-5.1c1.5-.9 2.8-2.1 3.9-3.5c7.1-8.9 13.6-18.2 19.5-28l.2-.3L480 380l.1-.3c5.4-9.7 10.2-19.9 14.3-30.4c.6-1.6 1-3.3 1.1-5c.5-10.8-3.3-21.6-11.2-29.8l-34.5-35.7c-1.6-1.7-2.7-4.4-2.4-7.8c.4-5 .6-10 .6-15s-.2-10.1-.6-15c-.3-3.4 .8-6.2 2.4-7.8l34.5-35.7c7.9-8.2 11.7-19 11.2-29.8c-.1-1.7-.5-3.4-1.1-5c-4.1-10.5-8.9-20.6-14.3-30.4l-.1-.3-4.4-7.6-.2-.3c-5.9-9.8-12.4-19.2-19.5-28c-1.1-1.4-2.4-2.6-3.9-3.5c-9-5.7-20.2-7.8-31.1-5.1l-48.2 12c-2.2 .6-5.2 .1-8-1.8c-8.2-5.7-16.9-10.7-26-15c-3.1-1.5-4.9-3.8-5.6-6L319.4 29c-3.1-10.8-10.5-19.5-20-24.5c-1.6-.8-3.2-1.4-5-1.6C281.9 1 269 0 256 0zM200 256a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm144 0a88 88 0 1 0 -176 0 88 88 0 1 0 176 0z'
      
    ]
  };

  
    var faCog = faGear;
  

  
  

  var faMinus = {
    prefix: 'fal',
    iconName: 'minus',
    icon: [
      448,
      512,
      [8211,8722,10134,"subtract"],
      'f068',
      
      'M432 256c0 8.8-7.2 16-16 16L32 272c-8.8 0-16-7.2-16-16s7.2-16 16-16l384 0c8.8 0 16 7.2 16 16z'
      
    ]
  };

  
    var faSubtract = faMinus;
  

  
  

  var faBallPile = {
    prefix: 'fal',
    iconName: 'ball-pile',
    icon: [
      576,
      512,
      [],
      'f77e',
      
      'M352 96A64 64 0 1 0 224 96a64 64 0 1 0 128 0zm-35.4 91.7c-9 2.8-18.6 4.3-28.6 4.3s-19.5-1.5-28.6-4.3C277.1 205.1 288 229.3 288 256s-10.9 50.9-28.6 68.3c9-2.8 18.6-4.3 28.6-4.3s19.5 1.5 28.6 4.3C298.9 306.9 288 282.7 288 256s10.9-50.9 28.6-68.3zM384 352c-9.9 0-19.5-1.5-28.6-4.3C373.1 365.1 384 389.3 384 416c0 53-43 96-96 96s-96-43-96-96c0-26.7 10.9-50.9 28.6-68.3c-9 2.8-18.6 4.3-28.6 4.3s-19.5-1.5-28.6-4.3C181.1 365.1 192 389.3 192 416c0 53-43 96-96 96s-96-43-96-96s43-96 96-96c9.9 0 19.5 1.5 28.6 4.3C106.9 306.9 96 282.7 96 256c0-53 43-96 96-96c9.9 0 19.5 1.5 28.6 4.3C202.9 146.9 192 122.7 192 96c0-53 43-96 96-96s96 43 96 96c0 26.7-10.9 50.9-28.6 68.3c9-2.8 18.6-4.3 28.6-4.3c53 0 96 43 96 96c0 26.7-10.9 50.9-28.6 68.3c9-2.8 18.6-4.3 28.6-4.3c53 0 96 43 96 96s-43 96-96 96s-96-43-96-96c0-26.7 10.9-50.9 28.6-68.3c-9 2.8-18.6 4.3-28.6 4.3zM256 256a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM160 416A64 64 0 1 0 32 416a64 64 0 1 0 128 0zm224-96a64 64 0 1 0 0-128 64 64 0 1 0 0 128zM288 480a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm256-64a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z'
      
    ]
  };

  

  
  

  var faArrowRotateLeft = {
    prefix: 'fal',
    iconName: 'arrow-rotate-left',
    icon: [
      512,
      512,
      [8634,"arrow-left-rotate","arrow-rotate-back","arrow-rotate-backward","undo"],
      'f0e2',
      
      'M48 192c-8.8 0-16-7.2-16-16L32 48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 92.6C103.2 75.5 174.5 32 256 32c123.7 0 224 100.3 224 224s-100.3 224-224 224c-79.9 0-150-41.8-189.7-104.8C59.8 364.8 67.7 352 80 352c6 0 11.4 3.2 14.7 8.2C128.9 413 188.4 448 256 448c106 0 192-86 192-192s-86-192-192-192c-71.1 0-133.1 38.6-166.3 96l86.3 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L48 192z'
      
    ]
  };

  
    var faArrowLeftRotate = faArrowRotateLeft;
  
    var faArrowRotateBack = faArrowRotateLeft;
  
    var faArrowRotateBackward = faArrowRotateLeft;
  
    var faUndo = faArrowRotateLeft;
  

  
  

  var faLandmark = {
    prefix: 'fal',
    iconName: 'landmark',
    icon: [
      512,
      512,
      [127963],
      'f66f',
      
      'M263.9 2.1C259-.7 253-.7 248.1 2.1L15.8 133.7C6 139.3 0 149.6 0 160.8C0 178 14 192 31.2 192l449.7 0c17.2 0 31.2-14 31.2-31.2c0-11.2-6-21.6-15.8-27.1L263.9 2.1zM256 34.4L477.7 160 34.3 160 256 34.4zM64 352c-8.8 0-16 7.2-16 16s7.2 16 16 16l384 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l0-128-32 0 0 128-80 0 0-128-32 0 0 128-96 0 0-128-32 0 0 128-80 0 0-128-32 0 0 128zM24 432c0 8.8 7.2 16 16 16l432 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L40 416c-8.8 0-16 7.2-16 16zM0 496c0 8.8 7.2 16 16 16l480 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L16 480c-8.8 0-16 7.2-16 16z'
      
    ]
  };

  

  
  

  var faCircleInfo = {
    prefix: 'fal',
    iconName: 'circle-info',
    icon: [
      512,
      512,
      ["info-circle"],
      'f05a',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM208 352c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0 0-112c0-8.8-7.2-16-16-16l-40 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l24 0 0 96-32 0zm48-168a24 24 0 1 0 0-48 24 24 0 1 0 0 48z'
      
    ]
  };

  
    var faInfoCircle = faCircleInfo;
  

  
  

  var faAnglesUp = {
    prefix: 'fal',
    iconName: 'angles-up',
    icon: [
      448,
      512,
      ["angle-double-up"],
      'f102',
      
      'M234.7 68.1c-6.1-5.5-15.3-5.5-21.4 0l-160 144c-6.6 5.9-7.1 16-1.2 22.6s16 7.1 22.6 1.2L224 101.5 373.3 235.9c6.6 5.9 16.7 5.4 22.6-1.2s5.4-16.7-1.2-22.6l-160-144zm160 336l-160-144c-6.1-5.5-15.3-5.5-21.4 0l-160 144c-6.6 5.9-7.1 16-1.2 22.6s16 7.1 22.6 1.2L224 293.5 373.3 427.9c6.6 5.9 16.7 5.4 22.6-1.2s5.4-16.7-1.2-22.6z'
      
    ]
  };

  
    var faAngleDoubleUp = faAnglesUp;
  

  
  

  var faUserSecret = {
    prefix: 'fal',
    iconName: 'user-secret',
    icon: [
      448,
      512,
      [128373],
      'f21b',
      
      'M169.1 37.7c-5.8 6.6-12 17.3-18.1 31.9c-6.1 14.5-11.3 31-15.5 47.2c24.4 6.4 54 11.2 88.6 11.2c33.4 0 63.3-5.2 88.3-12.1c-4.2-15.9-9.3-32-15.3-46.3c-6.1-14.6-12.4-25.3-18.1-31.9c-4-4.6-6.3-5.6-7-5.7c-4.8 0-7.3 .6-8.5 1c-1 .3-1.9 .8-3.6 1.8c-.1 .1-.4 .3-.7 .5C255.7 37.9 242.2 48 224 48s-31.7-10.1-35.1-12.7c0 0 0 0 0 0c-.3-.3-.6-.4-.7-.5c-1.6-1.1-2.5-1.5-3.6-1.8c-1.1-.4-3.6-1-8.5-1c-.6 .2-3 1.2-7 5.7zM272 0c34.2 0 57 54.9 70.8 106c.8-.3 1.6-.6 2.4-.9c14.8-5.7 26.5-11.4 34.3-15.7c3.9-2.1 6.9-3.9 8.9-5c1-.6 1.7-1 2.2-1.3l.5-.3c2.6-1.7 5.6-2.7 9-2.7c8.8 0 16 7.2 16 16c0 5.7-3 10.7-7.4 13.5c0 0 0 0 0 0l-.8 .5c-.7 .4-1.6 1-2.8 1.7c-2.4 1.4-5.8 3.5-10.3 5.8c-8.9 4.8-21.7 11.1-37.9 17.3C324.4 147.4 278.4 160 224 160c-58.3 0-104.3-12.5-135.9-25.1c-15.8-6.3-28-12.7-36.3-17.5c-4.2-2.4-7.4-4.5-9.6-6c-1.1-.7-2-1.3-2.6-1.8l-.7-.5-.1-.1c-4-2.9-6.7-7.6-6.7-13c0-8.8 7.2-16 16-16c3.6 0 6.9 1.2 9.6 3.2l.4 .3c.4 .3 1 .7 1.8 1.3c1.7 1.1 4.4 2.8 7.9 4.9c7.2 4.2 18 9.8 32.2 15.5c1.6 .6 3.3 1.3 5 1.9C118.7 55.7 141.5 0 176 0c18 0 25.9 5.4 32.5 9.9c4.7 3.3 8.8 6.1 15.5 6.1s10.8-2.8 15.5-6.1C246.1 5.4 254 0 272 0zm-.3 32s.1 0 .2 0c-.1 0-.2 0-.2 0zm-95.6 0c.1 0 .2 0 .2 0s-.1 0-.2 0zM100 224c-2.6-10.2-4-21-4-32c0-6.7 .5-13.3 1.5-19.7c9.6 3.1 19.9 6.1 31.1 8.8c-.4 3.6-.6 7.2-.6 10.9c0 53 43 96 96 96s96-43 96-96c0-4-.2-7.9-.7-11.7c11.1-2.8 21.5-5.8 31-9c1.1 6.8 1.7 13.7 1.7 20.8c0 11-1.4 21.8-4 32l71.2 0c7.1 0 12.8 5.7 12.8 12.8c0 2.1-.5 4.1-1.5 6l-45.7 86.8C423.6 364.8 448 415.5 448 472l0 8c0 17.7-14.3 32-32 32l-143.6 0c-.2 0-.5 0-.7 0l-95.3 0c-.2 0-.5 0-.7 0L32 512c-17.7 0-32-14.3-32-32l0-8c0-56.5 24.4-107.2 63.2-142.4L17.5 242.8c-1-1.8-1.5-3.9-1.5-6c0-7.1 5.7-12.8 12.8-12.8l71.2 0zm234.8 32c-22.1 38.3-63.5 64-110.9 64s-88.7-25.7-110.9-64l-52.5 0 30.9 58.7c6.8 12.9 4 28.8-6.8 38.6C52.3 382.7 32 424.9 32 472l0 8 122.8 0-26.2-91.6c-2.4-8.5 2.5-17.4 11-19.8s17.4 2.5 19.8 11l20.3 70.9L201.8 384l-9.8 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l32 0 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-9.8 0 22.2 66.5 20.3-70.9c2.4-8.5 11.3-13.4 19.8-11s13.4 11.3 11 19.8L293.2 480 416 480l0-8c0-47.1-20.3-89.3-52.7-118.6c-10.8-9.8-13.6-25.7-6.8-38.6L387.4 256l-52.5 0zM244.5 480L224 418.6 203.5 480l40.9 0zM144 184.4c10.1 2 20.8 3.6 32 4.9l0 8.7c0 7 5.7 12.7 12.7 12.7c5.5 0 10.3-3.5 12-8.7l3.5-10.5c6.5 .3 13.1 .5 19.8 .5c6.7 0 13.3-.2 19.8-.5l3.5 10.5c1.7 5.2 6.6 8.7 12 8.7c7 0 12.7-5.7 12.7-12.7l0-9c11.2-1.4 21.8-3.2 32-5.3l0 14.3c0 24.7-20 44.7-44.7 44.7c-14.1 0-27-6.6-35.3-17.3c-8.3 10.7-21.2 17.3-35.3 17.3c-24.7 0-44.7-20-44.7-44.7l0-13.6z'
      
    ]
  };

  

  
  

  var faFilePdf = {
    prefix: 'fal',
    iconName: 'file-pdf',
    icon: [
      512,
      512,
      [],
      'f1c1',
      
      'M64 480l48 0 0 32-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L220.1 0c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9L384 304l-32 0 0-112-112 0c-26.5 0-48-21.5-48-48l0-112L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32zM351.5 160c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2L224 144c0 8.8 7.2 16 16 16l111.5 0zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z'
      
    ]
  };

  

  
  

  var faTrash = {
    prefix: 'fal',
    iconName: 'trash',
    icon: [
      448,
      512,
      [],
      'f1f8',
      
      'M177.7 32l92.5 0c5.5 0 10.6 2.8 13.6 7.5L299.1 64 148.9 64l15.3-24.5c2.9-4.7 8.1-7.5 13.6-7.5zM336.9 64L311 22.6C302.2 8.5 286.8 0 270.3 0L177.7 0C161.2 0 145.8 8.5 137 22.6L111.1 64 64.1 64 32 64 16 64C7.2 64 0 71.2 0 80s7.2 16 16 16l18.3 0L59.8 452.6C62.1 486.1 90 512 123.6 512l200.8 0c33.6 0 61.4-25.9 63.8-59.4L413.7 96 432 96c8.8 0 16-7.2 16-16s-7.2-16-16-16l-16 0-32.1 0-47.1 0zm44.8 32L356.3 450.3C355.1 467 341.2 480 324.4 480l-200.8 0c-16.8 0-30.7-13-31.9-29.7L66.4 96l315.3 0z'
      
    ]
  };

  

  
  

  var faArrowRotateRight = {
    prefix: 'fal',
    iconName: 'arrow-rotate-right',
    icon: [
      512,
      512,
      [8635,"arrow-right-rotate","arrow-rotate-forward","redo"],
      'f01e',
      
      'M464 192c8.8 0 16-7.2 16-16l0-128c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 92.6C408.8 75.5 337.5 32 256 32C132.3 32 32 132.3 32 256s100.3 224 224 224c79.9 0 150-41.8 189.7-104.8c6.6-10.4-1.4-23.2-13.7-23.2c-6 0-11.4 3.2-14.7 8.2C383.1 413 323.6 448 256 448C150 448 64 362 64 256S150 64 256 64c71.1 0 133.1 38.6 166.3 96L336 160c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0z'
      
    ]
  };

  
    var faArrowRightRotate = faArrowRotateRight;
  
    var faArrowRotateForward = faArrowRotateRight;
  
    var faRedo = faArrowRotateRight;
  

  
  

  var faFloppyDisk = {
    prefix: 'fal',
    iconName: 'floppy-disk',
    icon: [
      448,
      512,
      [128190,128426,"save"],
      'f0c7',
      
      'M32 96c0-17.7 14.3-32 32-32l0 96c0 17.7 14.3 32 32 32l192 0c17.7 0 32-14.3 32-32l0-94.2c4.5 1.6 8.7 4.2 12.1 7.6l74.5 74.5c6 6 9.4 14.1 9.4 22.6L416 416c0 17.7-14.3 32-32 32L64 448c-17.7 0-32-14.3-32-32L32 96zM96 64l192 0 0 96L96 160l0-96zM0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-245.5c0-17-6.7-33.3-18.7-45.3L354.7 50.7c-12-12-28.3-18.7-45.3-18.7L64 32C28.7 32 0 60.7 0 96zM272 320a48 48 0 1 1 -96 0 48 48 0 1 1 96 0zm-48-80a80 80 0 1 0 0 160 80 80 0 1 0 0-160z'
      
    ]
  };

  
    var faSave = faFloppyDisk;
  

  
  

  var faPen = {
    prefix: 'fal',
    iconName: 'pen',
    icon: [
      512,
      512,
      [128394],
      'f304',
      
      'M395.8 39.6c9.4-9.4 24.6-9.4 33.9 0l42.6 42.6c9.4 9.4 9.4 24.6 0 33.9L417.6 171 341 94.4l54.8-54.8zM318.4 117L395 193.6 159.6 428.9c-7.6 7.6-16.9 13.1-27.2 16.1L39.6 472.4l27.3-92.8c3-10.3 8.6-19.6 16.1-27.2L318.4 117zM452.4 17c-21.9-21.9-57.3-21.9-79.2 0L60.4 329.7c-11.4 11.4-19.7 25.4-24.2 40.8L.7 491.5c-1.7 5.6-.1 11.7 4 15.8s10.2 5.7 15.8 4l121-35.6c15.4-4.5 29.4-12.9 40.8-24.2L495 138.8c21.9-21.9 21.9-57.3 0-79.2L452.4 17z'
      
    ]
  };

  

  
  

  var faEye = {
    prefix: 'fal',
    iconName: 'eye',
    icon: [
      576,
      512,
      [128065],
      'f06e',
      
      'M117.2 136C160.3 96 217.6 64 288 64s127.7 32 170.8 72c43.1 40 71.9 88 85.2 120c-13.3 32-42.1 80-85.2 120c-43.1 40-100.4 72-170.8 72s-127.7-32-170.8-72C74.1 336 45.3 288 32 256c13.3-32 42.1-80 85.2-120zM288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM192 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zm224 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z'
      
    ]
  };

  

  
  

  var faBarsProgress = {
    prefix: 'fal',
    iconName: 'bars-progress',
    icon: [
      512,
      512,
      ["tasks-alt"],
      'f828',
      
      'M464 96c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-144 0 0-96 144 0zM48 96l240 0 0 96L48 192c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zm0-32C21.5 64 0 85.5 0 112l0 64c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48L48 64zM464 320c8.8 0 16 7.2 16 16l0 64c0 8.8-7.2 16-16 16l-272 0 0-96 272 0zM48 320l112 0 0 96L48 416c-8.8 0-16-7.2-16-16l0-64c0-8.8 7.2-16 16-16zm0-32c-26.5 0-48 21.5-48 48l0 64c0 26.5 21.5 48 48 48l416 0c26.5 0 48-21.5 48-48l0-64c0-26.5-21.5-48-48-48L48 288z'
      
    ]
  };

  
    var faTasksAlt = faBarsProgress;
  

  
  

  var faCircleQuestion = {
    prefix: 'fal',
    iconName: 'circle-question',
    icon: [
      512,
      512,
      [62108,"question-circle"],
      'f059',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm168.7-86.2c6.5-24.6 28.7-41.8 54.2-41.8l57.1 0c35.5 0 64 29 64 64.3c0 24-13.4 46.2-34.9 57.2L272 268.3l0 19.7c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-29.5c0-6 3.4-11.5 8.7-14.3l45.8-23.4c10.7-5.4 17.5-16.6 17.5-28.7c0-17.8-14.4-32.3-32-32.3l-57.1 0c-10.9 0-20.5 7.4-23.2 17.9l-.2 .7c-2.2 8.5-11 13.7-19.5 11.4s-13.7-11-11.4-19.5l.2-.7zM232 352a24 24 0 1 1 48 0 24 24 0 1 1 -48 0z'
      
    ]
  };

  
    var faQuestionCircle = faCircleQuestion;
  

  
  

  var faRecycle = {
    prefix: 'fal',
    iconName: 'recycle',
    icon: [
      512,
      512,
      [9842,9850,9851],
      'f1b8',
      
      'M193.7 35C206.9 13.3 230.5 0 256 0s49.1 13.3 62.3 35l77.8 127.8 11.1-54c1.8-8.7 10.2-14.2 18.9-12.4s14.2 10.2 12.4 18.9l-19.4 94.4c-.9 4.5-3.7 8.3-7.7 10.6s-8.7 2.8-13 1.3L307 191.2c-8.4-2.8-12.9-11.8-10.1-20.2s11.8-12.9 20.2-10.1l50.5 16.8L291 51.7C283.5 39.4 270.3 32 256 32s-27.5 7.4-35 19.7l-31.1 51.2c-4.6 7.5-14.4 9.9-21.9 5.4c-7.6-4.6-10-14.5-5.4-22L193.7 35zM435.2 257.8c7.5-4.5 17.3-2.1 21.9 5.4l46 75.6c5.8 9.5 8.9 20.3 8.9 31.4c.3 34.1-27.3 61.9-61.4 61.9l-184.5 0 40.5 36c6.6 5.9 7.2 16 1.3 22.6s-16 7.2-22.6 1.3l-72-64c-3.4-3-5.4-7.4-5.4-12s2-8.9 5.4-12l72-64c6.6-5.9 16.7-5.3 22.6 1.3s5.3 16.7-1.3 22.6L266.1 400l184.6 0c16.3 0 29.5-13.3 29.4-29.6c0-5.3-1.5-10.5-4.3-15l-46-75.6c-4.6-7.6-2.2-17.5 5.4-22zm-300-.2l-10-48.4L36.3 355.3c-2.8 4.5-4.2 9.7-4.3 15C31.9 386.7 45.1 400 61.4 400l82.7 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-82.7 0C27.3 432-.3 404.2 0 370.1c.1-11.1 3.2-21.9 8.9-31.4l92.4-151.9L45 205.5c-8.4 2.8-17.4-1.8-20.2-10.1S26.6 178 35 175.2l91.4-30.4c4.3-1.4 9.1-1 13 1.3s6.7 6.2 7.7 10.6l19.4 94.4c1.8 8.7-3.8 17.1-12.4 18.9s-17.1-3.8-18.9-12.4z'
      
    ]
  };

  

  
  

  var faCircle = {
    prefix: 'fal',
    iconName: 'circle',
    icon: [
      512,
      512,
      [9679,9898,9899,11044,61708,61915,128308,128309,128992,128993,128994,128995,128996],
      'f111',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512z'
      
    ]
  };

  

  
  

  var faScrewdriverWrench = {
    prefix: 'fal',
    iconName: 'screwdriver-wrench',
    icon: [
      512,
      512,
      ["tools"],
      'f7d9',
      
      'M64.7 34.6L160 107.9l0 52.1-52.1 0L34.6 64.7 64.7 34.6zM192 169.3c0-.4 0-.9 0-1.3l0-64c0-7.5-3.5-14.5-9.4-19L78.6 5C69.1-2.4 55.6-1.5 47 7L7 47c-8.5 8.5-9.4 22-2.1 31.6l80 104c4.5 5.9 11.6 9.4 19 9.4l64 0c.4 0 .9 0 1.3 0L271.2 293.9c-19.5 30-16.2 70.5 10.1 96.8l112 112c12.5 12.5 32.8 12.5 45.3 0l64-64c12.5-12.5 12.5-32.8 0-45.3l-112-112c-26.3-26.3-66.8-29.7-96.8-10.1L192 169.3zM304 304c17.7-17.7 46.3-17.7 64 0L480 416l-64 64L304 368c-17.7-17.7-17.7-46.3 0-64zM104 424a16 16 0 1 0 -32 0 16 16 0 1 0 32 0zM23.2 376.8C8.3 391.7 0 411.8 0 432.8C0 476.5 35.5 512 79.2 512c21 0 41.1-8.3 56-23.2L238.5 385.5c-5.7-11.2-9.3-23.1-10.9-35.3L112.1 465.7c-8.7 8.7-20.6 13.6-32.9 13.6c-25.7 0-46.6-20.8-46.6-46.6c0-12.3 4.9-24.2 13.6-32.9L189.1 257l-23.1-23.1L23.2 376.8zM479.4 160c0 44.8-23.1 84.1-58 106.8l23.5 23.5c40.7-29 67.2-76.6 67.2-130.3c0-24.8-5.7-48.3-15.7-69.3c-4.4-9.2-16.5-10.5-23.7-3.3l-67.9 67.9c-3 3-7.1 4.7-11.3 4.7L368 160c-8.8 0-16-7.2-16-16l0-25.4c0-4.2 1.7-8.3 4.7-11.3l67.9-67.9c7.2-7.2 5.9-19.3-3.3-23.7C400.3 5.7 376.8 0 352 0C296.1 0 246.9 28.6 218.3 72.1l26 20C266.8 56.3 306.7 32.6 352 32.6c10.3 0 20.2 1.2 29.7 3.5L333.6 84.2c-9.1 9.1-14.2 21.5-14.2 34.4l0 25.4c0 26.9 21.8 48.6 48.6 48.6l25.4 0c12.9 0 25.3-5.1 34.4-14.2l48.1-48.1c2.3 9.5 3.5 19.5 3.5 29.7z'
      
    ]
  };

  
    var faTools = faScrewdriverWrench;
  

  
  

  var faArrowRight = {
    prefix: 'fal',
    iconName: 'arrow-right',
    icon: [
      448,
      512,
      [8594],
      'f061',
      
      'M443.3 267.3c6.2-6.2 6.2-16.4 0-22.6l-176-176c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L393.4 240 16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l377.4 0L244.7 420.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l176-176z'
      
    ]
  };

  

  
  

  var faFileExcel = {
    prefix: 'fal',
    iconName: 'file-excel',
    icon: [
      384,
      512,
      [],
      'f1c3',
      
      'M320 480L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l128 0 0 112c0 26.5 21.5 48 48 48l112 0 0 256c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16l0-111.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4L240 160zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-284.1c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1L64 0zm85.1 246.8c-5.1-7.2-15-9-22.3-3.9s-9 15-3.9 22.3L172.5 336l-49.6 70.8c-5.1 7.2-3.3 17.2 3.9 22.3s17.2 3.3 22.3-3.9L192 363.9l42.9 61.3c5.1 7.2 15 9 22.3 3.9s9-15 3.9-22.3L211.5 336l49.6-70.8c5.1-7.2 3.3-17.2-3.9-22.3s-17.2-3.3-22.3 3.9L192 308.1l-42.9-61.3z'
      
    ]
  };

  

  
  

  var faPuzzlePiece = {
    prefix: 'fal',
    iconName: 'puzzle-piece',
    icon: [
      512,
      512,
      [129513],
      'f12e',
      
      'M169.1 17.3C183.8 6.3 203.2 0 224 0s40.2 6.3 54.9 17.3S304 44.6 304 64c0 19.5-10.6 35.9-25.3 46.8c-5.2 3.8-6.7 7.7-6.7 10c0 4 3.2 7.2 7.2 7.2l56.8 0c26.5 0 48 21.5 48 48l0 56.8c0 4 3.2 7.2 7.2 7.2c2.3 0 6.1-1.6 10-6.7c11-14.7 27.4-25.3 46.8-25.3c19.4 0 35.8 10.5 46.7 25.1s17.3 34.1 17.3 54.9s-6.3 40.2-17.3 54.9s-27.3 25.1-46.7 25.1c-19.5 0-35.9-10.6-46.8-25.3c-3.8-5.2-7.7-6.7-10-6.7c-4 0-7.2 3.2-7.2 7.2L384 464c0 26.5-21.5 48-48 48l-56.8 0c-21.6 0-39.2-17.5-39.2-39.2c0-16.2 9.9-28.4 19.6-35.6c8.6-6.4 12.4-14.1 12.4-21.2c0-7.1-3.8-14.7-12.3-21.1s-21.1-10.9-35.7-10.9s-27.1 4.4-35.7 10.9s-12.3 14.1-12.3 21.1c0 7.1 3.8 14.8 12.4 21.2c9.7 7.2 19.6 19.4 19.6 35.6c0 21.7-17.5 39.2-39.2 39.2L48 512c-26.5 0-48-21.5-48-48L0 343.2C0 321.5 17.5 304 39.2 304c16.2 0 28.4 9.9 35.6 19.6C81.2 332.2 88.9 336 96 336c7.1 0 14.7-3.8 21.1-12.3s10.9-21.1 10.9-35.7s-4.4-27.1-10.9-35.7S103.1 240 96 240c-7.1 0-14.8 3.8-21.2 12.4C67.6 262.1 55.4 272 39.2 272C17.5 272 0 254.5 0 232.8L0 176c0-26.5 21.5-48 48-48l120.8 0c4 0 7.2-3.2 7.2-7.2c0-2.3-1.6-6.1-6.7-10C154.6 99.9 144 83.5 144 64c0-19.4 10.5-35.8 25.1-46.7zm19.2 25.6C179.8 49.3 176 56.9 176 64c0 7.1 3.8 14.8 12.4 21.2c9.7 7.2 19.6 19.4 19.6 35.6c0 21.6-17.5 39.2-39.2 39.2L48 160c-8.8 0-16 7.2-16 16l0 56.8c0 4 3.2 7.2 7.2 7.2c2.3 0 6.1-1.6 10-6.7C60.1 218.6 76.5 208 96 208c19.4 0 35.8 10.5 46.7 25.1s17.3 34.1 17.3 54.9s-6.3 40.2-17.3 54.9S115.4 368 96 368c-19.5 0-35.9-10.6-46.8-25.3c-3.8-5.2-7.7-6.7-10-6.7c-4 0-7.2 3.2-7.2 7.2L32 464c0 8.8 7.2 16 16 16l120.8 0c4 0 7.2-3.2 7.2-7.2c0-2.3-1.6-6.1-6.7-10c-14.7-11-25.3-27.4-25.3-46.8c0-19.4 10.5-35.8 25.1-46.7s34.1-17.3 54.9-17.3s40.2 6.3 54.9 17.3s25.1 27.3 25.1 46.7c0 19.5-10.6 35.9-25.3 46.8c-5.2 3.8-6.7 7.7-6.7 10c0 4 3.2 7.2 7.2 7.2l56.8 0c8.8 0 16-7.2 16-16l0-120.8c0-21.7 17.5-39.2 39.2-39.2c16.2 0 28.4 9.9 35.6 19.6c6.4 8.6 14.1 12.4 21.2 12.4c7.1 0 14.7-3.8 21.1-12.3s10.9-21.1 10.9-35.7s-4.4-27.1-10.9-35.7s-14.1-12.3-21.1-12.3c-7.1 0-14.8 3.8-21.2 12.4c-7.2 9.7-19.4 19.6-35.6 19.6c-21.7 0-39.2-17.5-39.2-39.2l0-56.8c0-8.8-7.2-16-16-16l-56.8 0c-21.6 0-39.2-17.5-39.2-39.2c0-16.2 9.9-28.4 19.6-35.6C268.2 78.8 272 71.1 272 64c0-7.1-3.8-14.7-12.3-21.1S238.5 32 224 32s-27.1 4.4-35.7 10.9z'
      
    ]
  };

  

  
  

  var faFilter = {
    prefix: 'fal',
    iconName: 'filter',
    icon: [
      512,
      512,
      [],
      'f0b0',
      
      'M0 71.5C0 49.7 17.7 32 39.5 32l432.9 0C494.3 32 512 49.7 512 71.5c0 9.2-3.2 18.1-9.1 25.2L320 317.8l0 128.4c0 18.7-15.2 33.9-33.9 33.9c-7.5 0-14.8-2.5-20.8-7.1l-61-47.4c-7.8-6.1-12.4-15.4-12.4-25.3l0-82.4L9.1 96.7C3.2 89.6 0 80.7 0 71.5zM39.5 64c-4.2 0-7.5 3.4-7.5 7.5c0 1.8 .6 3.4 1.7 4.8L220.3 301.8c2.4 2.9 3.7 6.5 3.7 10.2l0 88.2 61 47.4c.3 .3 .7 .4 1.1 .4c1 0 1.9-.8 1.9-1.9L288 312c0-3.7 1.3-7.3 3.7-10.2L478.3 76.3c1.1-1.3 1.7-3 1.7-4.8c0-4.2-3.4-7.5-7.5-7.5L39.5 64z'
      
    ]
  };

  

  
  

  var faListOl = {
    prefix: 'fal',
    iconName: 'list-ol',
    icon: [
      512,
      512,
      ["list-1-2","list-numeric"],
      'f0cb',
      
      'M32 48c0 8.8 7.2 16 16 16l16 0 0 128-32 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-32 0L96 48c0-8.8-7.2-16-16-16L48 32c-8.8 0-16 7.2-16 16zM192 96c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L208 80c-8.8 0-16 7.2-16 16zm0 160c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-288 0c-8.8 0-16 7.2-16 16zm0 160c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-288 0c-8.8 0-16 7.2-16 16zM58.7 323.9c11.1-11.1 29.2-10.5 39.6 1.3c9.2 10.5 8.9 26.2-.6 36.3L12.3 453.1c-4.3 4.7-5.5 11.5-3 17.3s8.3 9.6 14.7 9.6l104 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-67.2 0 60.3-64.6c20.7-22.2 21.2-56.4 1.3-79.3c-22.5-25.7-62.1-27.1-86.3-2.9L20.7 316.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l15.4-15.4z'
      
    ]
  };

  
    var faList12 = faListOl;
  
    var faListNumeric = faListOl;
  

  
  

  var faArrowTurnDownRight = {
    prefix: 'fal',
    iconName: 'arrow-turn-down-right',
    icon: [
      512,
      512,
      [],
      'e3d6',
      
      'M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48L0 224c0 44.2 35.8 80 80 80l377.4 0L356.7 404.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l128-128c6.2-6.2 6.2-16.4 0-22.6l-128-128c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L457.4 272 80 272c-26.5 0-48-21.5-48-48L32 48z'
      
    ]
  };

  

  
  

  var faFileZipper = {
    prefix: 'fal',
    iconName: 'file-zipper',
    icon: [
      384,
      512,
      ["file-archive"],
      'f1c6',
      
      'M352 448l0-256-112 0c-26.5 0-48-21.5-48-48l0-112L64 32C46.3 32 32 46.3 32 64l0 384c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32zm-.5-288c-.7-2.8-2.1-5.4-4.2-7.4L231.4 36.7c-2.1-2.1-4.6-3.5-7.4-4.2L224 144c0 8.8 7.2 16 16 16l111.5 0zM0 64C0 28.7 28.7 0 64 0L220.1 0c12.7 0 24.9 5.1 33.9 14.1L369.9 129.9c9 9 14.1 21.2 14.1 33.9L384 448c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 64zM64 80c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 96c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16zm0 64c0-8.8 7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0c-8.8 0-16-7.2-16-16zm32 48l32 0c7.1 0 13.4 4.7 15.4 11.6L158 318.9c1.3 4.6 2 9.3 2 14l0 3.1c0 26.5-21.5 48-48 48s-48-21.5-48-48l0-3.1c0-4.7 .7-9.5 2-14l14.7-51.3c2-6.9 8.2-11.6 15.4-11.6zm.7 71.7c-.5 1.7-.7 3.5-.7 5.2l0 3.1c0 8.8 7.2 16 16 16s16-7.2 16-16l0-3.1c0-1.8-.2-3.5-.7-5.2L115.9 288l-7.9 0L96.7 327.7z'
      
    ]
  };

  
    var faFileArchive = faFileZipper;
  

  
  

  var faBorderOuter = {
    prefix: 'fal',
    iconName: 'border-outer',
    icon: [
      448,
      512,
      [],
      'f851',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm224 88a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm-72 72a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zm72 24a24 24 0 1 1 0-48 24 24 0 1 1 0 48zm120-24a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM224 376a24 24 0 1 1 0-48 24 24 0 1 1 0 48z'
      
    ]
  };

  

  
  

  var faLayerGroup = {
    prefix: 'fal',
    iconName: 'layer-group',
    icon: [
      576,
      512,
      [],
      'f5fd',
      
      'M266.2 4.7C273 1.6 280.5 0 288 0s15 1.6 21.8 4.7l217.4 97.5c10.2 4.6 16.8 14.7 16.8 25.9s-6.6 21.3-16.8 25.9L309.8 251.3c-6.9 3.1-14.3 4.7-21.8 4.7s-15-1.6-21.8-4.7L48.8 153.9C38.6 149.3 32 139.2 32 128s6.6-21.3 16.8-25.9L266.2 4.7zM288 32c-3 0-6 .6-8.8 1.9L69.3 128l210 94.1c2.8 1.2 5.7 1.9 8.8 1.9s6-.6 8.8-1.9l210-94.1-210-94.1C294 32.6 291 32 288 32zM48.8 358.1l45.9-20.6 39.1 17.5L69.3 384l210 94.1c2.8 1.2 5.7 1.9 8.8 1.9s6-.6 8.8-1.9l210-94.1-64.5-28.9 39.1-17.5 45.9 20.6c10.2 4.6 16.8 14.7 16.8 25.9s-6.6 21.3-16.8 25.9L309.8 507.3c-6.9 3.1-14.3 4.7-21.8 4.7s-15-1.6-21.8-4.7L48.8 409.9C38.6 405.3 32 395.2 32 384s6.6-21.3 16.8-25.9zM94.7 209.5l39.1 17.5L69.3 256l210 94.1c2.8 1.2 5.7 1.9 8.8 1.9s6-.6 8.8-1.9l210-94.1-64.5-28.9 39.1-17.5 45.9 20.6c10.2 4.6 16.8 14.7 16.8 25.9s-6.6 21.3-16.8 25.9L309.8 379.3c-6.9 3.1-14.3 4.7-21.8 4.7s-15-1.6-21.8-4.7L48.8 281.9C38.6 277.3 32 267.2 32 256s6.6-21.3 16.8-25.9l45.9-20.6z'
      
    ]
  };

  

  
  

  var faArrowsLeftRight = {
    prefix: 'fal',
    iconName: 'arrows-left-right',
    icon: [
      512,
      512,
      ["arrows-h"],
      'f07e',
      
      'M507.3 271.3c6.1-6.1 6.3-15.9 .4-22.2l-96-104c-6-6.5-16.1-6.9-22.6-.9s-6.9 16.1-.9 22.6L459.5 244 54.6 244l68.7-68.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6l96 96c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L54.6 276l402.7 0-68.7 68.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96z'
      
    ]
  };

  
    var faArrowsH = faArrowsLeftRight;
  

  
  

  var faSquareDollar = {
    prefix: 'fal',
    iconName: 'square-dollar',
    icon: [
      448,
      512,
      ["dollar-square","usd-square"],
      'f2e9',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm240 24l0 23c13.5 1 26.6 4.6 39.6 8.3c1.5 .4 3.1 .9 4.6 1.3c8.5 2.4 13.5 11.2 11.2 19.7s-11.2 13.5-19.7 11.2c-2.4-.7-4.8-1.4-7.2-2.1c-7.5-2.2-15.2-4.4-22.9-5.5c-19.1-2.8-36.6-.4-49.3 5.1c-12.9 5.6-18.6 13.1-19.8 19.5c-1.8 9.8 2.1 16.5 10.2 21.7c10.6 6.8 26.5 11.3 45.8 16.8l.3 .1c17.7 5 38.9 11.1 54.3 21.7c19 13 27.8 33.8 23.6 56.5c-4 21.6-18.9 36-37.8 43.6c-9.9 4-21.1 6.3-33.1 6.9l0 24.2c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-25.9c-8.1-1.3-21.8-5.2-32.4-8.4c-6.9-2.1-13.8-4.3-20.7-6.5c-8.4-2.8-12.9-11.8-10.2-20.2s11.8-12.9 20.2-10.2c6.6 2.2 13.2 4.3 19.9 6.3c11.2 3.4 22.7 6.6 28.1 7.4c19.8 2.9 36.5 1.3 48-3.4c11.2-4.5 16.8-11.3 18.3-19.7c1.9-10.5-1.5-18.4-10.2-24.4c-12-8.2-26.8-12.3-40.9-16.2c-2.3-.6-4.7-1.3-6.9-1.9c-17.1-4.8-37-10.5-51.7-19.9c-8.1-5.2-15.7-12.1-20.5-21.7c-4.9-9.8-6.2-20.8-4-32.8c3.8-20.7 20-35.1 38.6-43.1c7.4-3.2 15.6-5.6 24.3-7.1l0-24.5c0-8.8 7.2-16 16-16s16 7.2 16 16z'
      
    ]
  };

  
    var faDollarSquare = faSquareDollar;
  
    var faUsdSquare = faSquareDollar;
  

  
  

  var faArrowDownWideShort = {
    prefix: 'fal',
    iconName: 'arrow-down-wide-short',
    icon: [
      576,
      512,
      ["sort-amount-asc","sort-amount-down"],
      'f160',
      
      'M235.3 379.3l-96 96c-6.2 6.2-16.4 6.2-22.6 0l-96-96c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L112 425.4 112 48c0-8.8 7.2-16 16-16s16 7.2 16 16l0 377.4 68.7-68.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6zM304 464c-8.8 0-16-7.2-16-16s7.2-16 16-16l64 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-64 0zm0-128c-8.8 0-16-7.2-16-16s7.2-16 16-16l128 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-128 0zm0-128c-8.8 0-16-7.2-16-16s7.2-16 16-16l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0zm0-128c-8.8 0-16-7.2-16-16s7.2-16 16-16l256 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L304 80z'
      
    ]
  };

  
    var faSortAmountAsc = faArrowDownWideShort;
  
    var faSortAmountDown = faArrowDownWideShort;
  

  
  

  var faCloudArrowUp = {
    prefix: 'fal',
    iconName: 'cloud-arrow-up',
    icon: [
      640,
      512,
      [62338,"cloud-upload","cloud-upload-alt"],
      'f0ee',
      
      'M389.8 125.2C363.7 88.1 320.7 64 272 64c-77.4 0-140.5 61-143.9 137.5c-.6 13-9 24.4-21.3 28.8C63.2 245.7 32 287.2 32 336c0 61.9 50.1 112 112 112l368 0c53 0 96-43 96-96c0-36.8-20.7-68.8-51.2-84.9c-13.4-7.1-20-22.5-15.8-37.1c2-6.9 3-14.3 3-22c0-44.2-35.8-80-80-80c-12.3 0-23.9 2.8-34.3 7.7c-14.1 6.7-30.9 2.3-39.9-10.5zM272 32c59.5 0 112.1 29.5 144 74.8C430.5 99.9 446.8 96 464 96c61.9 0 112 50.1 112 112c0 10.7-1.5 21-4.3 30.8C612.3 260.2 640 302.9 640 352c0 70.7-57.3 128-128 128l-368 0C64.5 480 0 415.5 0 336c0-62.8 40.2-116.1 96.2-135.9C100.3 106.6 177.4 32 272 32zM228.7 244.7l80-80c6.2-6.2 16.4-6.2 22.6 0l80 80c6.2 6.2 6.2 16.4 0 22.6s-16.4 6.2-22.6 0L336 214.6 336 368c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-153.4-52.7 52.7c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6z'
      
    ]
  };

  
    var faCloudUpload = faCloudArrowUp;
  
    var faCloudUploadAlt = faCloudArrowUp;
  

  
  

  var faCircleCheck = {
    prefix: 'fal',
    iconName: 'circle-check',
    icon: [
      512,
      512,
      [61533,"check-circle"],
      'f058',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM363.3 203.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0L224 297.4l-52.7-52.7c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l64 64c6.2 6.2 16.4 6.2 22.6 0l128-128z'
      
    ]
  };

  
    var faCheckCircle = faCircleCheck;
  

  
  

  var faCirclePlay = {
    prefix: 'fal',
    iconName: 'circle-play',
    icon: [
      512,
      512,
      [61469,"play-circle"],
      'f144',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm72.7-256L208 329.7l0-147.5L328.7 256zM212.5 147.5c-7.4-4.5-16.7-4.7-24.3-.5s-12.3 12.3-12.3 20.9l0 176c0 8.7 4.7 16.7 12.3 20.9s16.8 4.1 24.3-.5l144-88c7.1-4.4 11.5-12.1 11.5-20.5s-4.4-16.1-11.5-20.5l-144-88z'
      
    ]
  };

  
    var faPlayCircle = faCirclePlay;
  

  
  

  var faAnglesRight = {
    prefix: 'fal',
    iconName: 'angles-right',
    icon: [
      512,
      512,
      [187,"angle-double-right"],
      'f101',
      
      'M443.9 266.7c5.5-6.1 5.5-15.3 0-21.4l-144-160c-5.9-6.6-16-7.1-22.6-1.2s-7.1 16-1.2 22.6L410.5 256 276.1 405.3c-5.9 6.6-5.4 16.7 1.2 22.6s16.7 5.4 22.6-1.2l144-160zm-336 160l144-160c5.5-6.1 5.5-15.3 0-21.4l-144-160c-5.9-6.6-16-7.1-22.6-1.2s-7.1 16-1.2 22.6L218.5 256 84.1 405.3c-5.9 6.6-5.4 16.7 1.2 22.6s16.7 5.4 22.6-1.2z'
      
    ]
  };

  
    var faAngleDoubleRight = faAnglesRight;
  

  
  

  var faTableColumns = {
    prefix: 'fal',
    iconName: 'table-columns',
    icon: [
      512,
      512,
      ["columns"],
      'f0db',
      
      'M448 64c17.7 0 32 14.3 32 32l0 64L32 160l0-64c0-17.7 14.3-32 32-32l384 0zM32 416l0-224 208 0 0 256L64 448c-17.7 0-32-14.3-32-32zm240 32l0-256 208 0 0 224c0 17.7-14.3 32-32 32l-176 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z'
      
    ]
  };

  
    var faColumns = faTableColumns;
  

  
  

  var faSquarePlus = {
    prefix: 'fal',
    iconName: 'square-plus',
    icon: [
      448,
      512,
      [61846,"plus-square"],
      'f0fe',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM208 352l0-80-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-80c0-8.8 7.2-16 16-16s16 7.2 16 16l0 80 80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0 0 80c0 8.8-7.2 16-16 16s-16-7.2-16-16z'
      
    ]
  };

  
    var faPlusSquare = faSquarePlus;
  

  
  

  var faChartBar = {
    prefix: 'fal',
    iconName: 'chart-bar',
    icon: [
      512,
      512,
      ["bar-chart"],
      'f080',
      
      'M16 32c8.8 0 16 7.2 16 16l0 352c0 26.5 21.5 48 48 48l416 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 480c-44.2 0-80-35.8-80-80L0 48c0-8.8 7.2-16 16-16zM128 144c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16zm16 80l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zm0 96l288 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-288 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  
    var faBarChart = faChartBar;
  

  
  

  var faArrowDownToLine = {
    prefix: 'fal',
    iconName: 'arrow-down-to-line',
    icon: [
      384,
      512,
      ["arrow-to-bottom"],
      'f33d',
      
      'M16 480c-8.8 0-16-7.2-16-16s7.2-16 16-16l352 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 480zM203.3 379.3c-6.2 6.2-16.4 6.2-22.6 0l-128-128c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L176 329.4 176 224l0-176c0-8.8 7.2-16 16-16s16 7.2 16 16l0 176 0 105.4L308.7 228.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-128 128z'
      
    ]
  };

  
    var faArrowToBottom = faArrowDownToLine;
  

  
  

  var faFileArrowUp = {
    prefix: 'fal',
    iconName: 'file-arrow-up',
    icon: [
      384,
      512,
      ["file-upload"],
      'f574',
      
      'M320 480L64 480c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l128 0 0 112c0 26.5 21.5 48 48 48l112 0 0 256c0 17.7-14.3 32-32 32zM240 160c-8.8 0-16-7.2-16-16l0-111.5c2.8 .7 5.4 2.1 7.4 4.2L347.3 152.6c2.1 2.1 3.5 4.6 4.2 7.4L240 160zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-284.1c0-12.7-5.1-24.9-14.1-33.9L254.1 14.1c-9-9-21.2-14.1-33.9-14.1L64 0zM208 278.6l52.7 52.7c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-80-80c-6.2-6.2-16.4-6.2-22.6 0l-80 80c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0L176 278.6 176 400c0 8.8 7.2 16 16 16s16-7.2 16-16l0-121.4z'
      
    ]
  };

  
    var faFileUpload = faFileArrowUp;
  

  
  

  var faHouseDay = {
    prefix: 'fal',
    iconName: 'house-day',
    icon: [
      640,
      512,
      [],
      'e00e',
      
      'M192 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 48c0 8.8 7.2 16 16 16s16-7.2 16-16l0-48zM16 160c-8.8 0-16 7.2-16 16s7.2 16 16 16l48 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-48 0zM276.7 52.7l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0zM410.4 99.9c-6-5.1-14.8-5.1-20.8 0l-224 192c-6.7 5.8-7.5 15.9-1.7 22.6s15.9 7.5 22.6 1.7L224 283.9 224 448c0 35.3 28.7 64 64 64l224 0c35.3 0 64-28.7 64-64l0-164.1 37.6 32.2c6.7 5.7 16.8 5 22.6-1.7s5-16.8-1.7-22.6l-224-192zM544 256.5L544 448c0 17.7-14.3 32-32 32l-224 0c-17.7 0-32-14.3-32-32l0-191.5L400 133.1 544 256.5zM336 304l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0c-17.7 0-32 14.3-32 32zm96 0l0 64-64 0 0-64 64 0zM144 176c0-17.7 14.3-32 32-32c13.9 0 25.8 8.9 30.2 21.3c2.9 8.3 12.1 12.7 20.4 9.8s12.7-12.1 9.8-20.4C227.6 129.8 203.9 112 176 112c-35.3 0-64 28.7-64 64c0 27.9 17.8 51.6 42.7 60.4c8.3 2.9 17.5-1.4 20.4-9.8s-1.4-17.5-9.8-20.4C152.9 201.8 144 189.9 144 176zm-36.7 91.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32zM52.7 52.7c-6.2 6.2-6.2 16.4 0 22.6l32 32c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-32-32c-6.2-6.2-16.4-6.2-22.6 0z'
      
    ]
  };

  

  
  

  var faToggleOn = {
    prefix: 'fal',
    iconName: 'toggle-on',
    icon: [
      576,
      512,
      [],
      'f205',
      
      'M160 128C89.3 128 32 185.3 32 256s57.3 128 128 128l256 0c70.7 0 128-57.3 128-128s-57.3-128-128-128l-256 0zM0 256C0 167.6 71.6 96 160 96l256 0c88.4 0 160 71.6 160 160s-71.6 160-160 160l-256 0C71.6 416 0 344.4 0 256zm480 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z'
      
    ]
  };

  

  
  

  var faLayerPlus = {
    prefix: 'fal',
    iconName: 'layer-plus',
    icon: [
      576,
      512,
      ["layer-group-plus"],
      'f5ff',
      
      'M480 24c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 40-40 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l40 0 0 40c0 8.8 7.2 16 16 16s16-7.2 16-16l0-40 40 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-40 0 0-40zM288 128c-7.5 0-15 1.6-21.8 4.7L48.8 230.1C38.6 234.7 32 244.8 32 256s6.6 21.3 16.8 25.9l217.4 97.5c6.9 3.1 14.3 4.7 21.8 4.7s15-1.6 21.8-4.7l217.4-97.5c10.2-4.6 16.8-14.7 16.8-25.9s-6.6-21.3-16.8-25.9L309.8 132.7c-6.9-3.1-14.3-4.7-21.8-4.7zm-8.8 33.9c2.8-1.2 5.7-1.9 8.8-1.9s6 .6 8.8 1.9l210 94.1-210 94.1c-2.8 1.2-5.7 1.9-8.8 1.9s-6-.6-8.8-1.9L69.3 256l210-94.1zM94.7 337.5L48.8 358.1C38.6 362.7 32 372.8 32 384s6.6 21.3 16.8 25.9l217.4 97.5c6.9 3.1 14.3 4.7 21.8 4.7s15-1.6 21.8-4.7l217.4-97.5c10.2-4.6 16.8-14.7 16.8-25.9s-6.6-21.3-16.8-25.9l-45.9-20.6-39.1 17.5L506.7 384l-210 94.1c-2.8 1.2-5.7 1.9-8.8 1.9s-6-.6-8.8-1.9L69.3 384l64.5-28.9L94.7 337.5z'
      
    ]
  };

  
    var faLayerGroupPlus = faLayerPlus;
  

  
  

  var faUserGroup = {
    prefix: 'fal',
    iconName: 'user-group',
    icon: [
      640,
      512,
      [128101,"user-friends"],
      'f500',
      
      'M128 128a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM269.7 336c80 0 145 64.3 146.3 144L32 480c1.2-79.7 66.2-144 146.3-144l91.4 0zM224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0zm431 208c17 0 30.7-13.8 30.7-30.7C640 392.2 567.8 320 478.7 320l-61.4 0c-4.4 0-8.8 .2-13.2 .5c11.3 9.4 21.6 19.9 30.7 31.5l43.9 0c71 0 128.6 57.2 129.3 128l-128 0c0 .8 0 1.5 0 2.3c0 10.8-2.8 20.9-7.6 29.7l136.9 0zM432 256c61.9 0 112-50.1 112-112s-50.1-112-112-112c-24.8 0-47.7 8.1-66.3 21.7c5.2 9.8 9.3 20.3 12.4 31.2C392.3 71.9 411.2 64 432 64c44.2 0 80 35.8 80 80s-35.8 80-80 80c-25.2 0-47.6-11.6-62.3-29.8c-4.7 10.3-10.4 19.9-17 28.9C373 243.4 401 256 432 256z'
      
    ]
  };

  
    var faUserFriends = faUserGroup;
  

  
  

  var faArrowRightToBracket = {
    prefix: 'fal',
    iconName: 'arrow-right-to-bracket',
    icon: [
      512,
      512,
      ["sign-in"],
      'f090',
      
      'M347.3 267.3c6.2-6.2 6.2-16.4 0-22.6l-128-128c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L297.4 240 16 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l281.4 0L196.7 372.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l128-128zM336 448c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c44.2 0 80-35.8 80-80l0-288c0-44.2-35.8-80-80-80l-96 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l96 0c26.5 0 48 21.5 48 48l0 288c0 26.5-21.5 48-48 48l-96 0z'
      
    ]
  };

  
    var faSignIn = faArrowRightToBracket;
  

  
  

  var faChartArea = {
    prefix: 'fal',
    iconName: 'chart-area',
    icon: [
      512,
      512,
      ["area-chart"],
      'f1fe',
      
      'M32 48c0-8.8-7.2-16-16-16S0 39.2 0 48L0 400c0 44.2 35.8 80 80 80l416 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 448c-26.5 0-48-21.5-48-48L32 48zM297.4 214.6c6 6 14.1 9.4 22.6 9.4s16.6-3.4 22.6-9.4l39.6-39.6 62 72.3c2.5 2.9 3.9 6.6 3.9 10.4l0 94.2-320 0 0-108.1c0-4.2 1.7-8.3 4.7-11.3L224 141.3l73.4 73.4zm0-45.3l-50.7-50.7c-12.5-12.5-32.8-12.5-45.3 0l-91.3 91.3c-9 9-14.1 21.2-14.1 33.9L96 352c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-94.2c0-11.5-4.1-22.5-11.6-31.2l-62-72.3c-12.1-14.2-33.7-15-46.9-1.8l-16.9 16.9L320 192l-22.6-22.6z'
      
    ]
  };

  
    var faAreaChart = faChartArea;
  

  
  

  var faLocationArrow = {
    prefix: 'fal',
    iconName: 'location-arrow',
    icon: [
      448,
      512,
      [],
      'f124',
      
      'M224 224L48 224 400 80 256 432l0-176c0-17.7-14.3-32-32-32zm-32 32l32 0 0 32 0 144c0 15.3 10.8 28.4 25.8 31.4s30-5.1 35.8-19.3l144-352c4.9-11.9 2.1-25.6-7-34.7s-22.8-11.9-34.7-7l-352 144c-14.2 5.8-22.2 20.8-19.3 35.8s16.1 25.8 31.4 25.8l144 0z'
      
    ]
  };

  

  
  

  var faMessagePlus = {
    prefix: 'fal',
    iconName: 'message-plus',
    icon: [
      512,
      512,
      ["comment-alt-plus"],
      'f4a8',
      
      'M192 416c0-17.7-14.3-32-32-32l-96 0c-17.7 0-32-14.3-32-32L32 64c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32l0 288c0 17.7-14.3 32-32 32l-138.7 0c-6.9 0-13.7 2.2-19.2 6.4L192 464l0-48zM64 0C28.7 0 0 28.7 0 64L0 352c0 35.3 28.7 64 64 64l64 0 32 0 0 32 0 48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416 448 416c35.3 0 64-28.7 64-64l0-288c0-35.3-28.7-64-64-64L64 0zM240 304c0 8.8 7.2 16 16 16s16-7.2 16-16l0-80 80 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-80 0 0-80c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 80-80 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l80 0 0 80z'
      
    ]
  };

  
    var faCommentAltPlus = faMessagePlus;
  

  
  

  var faUser = {
    prefix: 'fal',
    iconName: 'user',
    icon: [
      448,
      512,
      [62144,128100],
      'f007',
      
      'M320 128a96 96 0 1 0 -192 0 96 96 0 1 0 192 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM32 480l384 0c-1.2-79.7-66.2-144-146.3-144l-91.4 0c-80 0-145 64.3-146.3 144zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3z'
      
    ]
  };

  

  
  

  var faFolder = {
    prefix: 'fal',
    iconName: 'folder',
    icon: [
      512,
      512,
      [61716,128193,128447,"folder-blank"],
      'f07b',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l384 0c17.7 0 32-14.3 32-32l0-256c0-17.7-14.3-32-32-32l-156.1 0c-17 0-33.3-6.7-45.3-18.7L210.7 73.4c-6-6-14.1-9.4-22.6-9.4L64 64zM0 96C0 60.7 28.7 32 64 32l124.1 0c17 0 33.3 6.7 45.3 18.7l35.9 35.9c6 6 14.1 9.4 22.6 9.4L448 96c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96z'
      
    ]
  };

  
    var faFolderBlank = faFolder;
  

  
  

  var faArrowLeftToLine = {
    prefix: 'fal',
    iconName: 'arrow-left-to-line',
    icon: [
      448,
      512,
      [8676,"arrow-to-left"],
      'f33e',
      
      'M0 432c0 8.8 7.2 16 16 16s16-7.2 16-16L32 80c0-8.8-7.2-16-16-16S0 71.2 0 80L0 432zM100.7 244.7c-6.2 6.2-6.2 16.4 0 22.6l128 128c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L150.6 272 256 272l176 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-176 0-105.4 0L251.3 139.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-128 128z'
      
    ]
  };

  
    var faArrowToLeft = faArrowLeftToLine;
  

  
  

  var faAngleRight = {
    prefix: 'fal',
    iconName: 'angle-right',
    icon: [
      320,
      512,
      [8250],
      'f105',
      
      'M267.3 244.7c6.2 6.2 6.2 16.4 0 22.6l-160 160c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6L233.4 256 84.7 107.3c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l160 160z'
      
    ]
  };

  

  
  

  var faPenToSquare = {
    prefix: 'fal',
    iconName: 'pen-to-square',
    icon: [
      512,
      512,
      ["edit"],
      'f044',
      
      'M454.6 45.3l12.1 12.1c12.5 12.5 12.5 32.8 0 45.3L440 129.4 382.6 72l26.7-26.7c12.5-12.5 32.8-12.5 45.3 0zM189 265.6l171-171L417.4 152l-171 171c-4.2 4.2-9.6 7.2-15.4 8.6l-65.6 15.1L180.5 281c1.3-5.8 4.3-11.2 8.6-15.4zm197.7-243L166.4 243c-8.5 8.5-14.4 19.2-17.1 30.9l-20.9 90.6c-1.2 5.4 .4 11 4.3 14.9s9.5 5.5 14.9 4.3l90.6-20.9c11.7-2.7 22.4-8.6 30.9-17.1L489.4 125.3c25-25 25-65.5 0-90.5L477.3 22.6c-25-25-65.5-25-90.5 0zM80 64C35.8 64 0 99.8 0 144L0 432c0 44.2 35.8 80 80 80l288 0c44.2 0 80-35.8 80-80l0-128c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 128c0 26.5-21.5 48-48 48L80 480c-26.5 0-48-21.5-48-48l0-288c0-26.5 21.5-48 48-48l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 64z'
      
    ]
  };

  
    var faEdit = faPenToSquare;
  

  
  

  var faLock = {
    prefix: 'fal',
    iconName: 'lock',
    icon: [
      448,
      512,
      [128274],
      'f023',
      
      'M128 128l0 64 192 0 0-64c0-53-43-96-96-96s-96 43-96 96zM96 192l0-64C96 57.3 153.3 0 224 0s128 57.3 128 128l0 64 16 0c44.2 0 80 35.8 80 80l0 160c0 44.2-35.8 80-80 80L80 512c-44.2 0-80-35.8-80-80L0 272c0-44.2 35.8-80 80-80l16 0zM32 272l0 160c0 26.5 21.5 48 48 48l288 0c26.5 0 48-21.5 48-48l0-160c0-26.5-21.5-48-48-48L80 224c-26.5 0-48 21.5-48 48z'
      
    ]
  };

  

  
  

  var faCircleDot = {
    prefix: 'fal',
    iconName: 'circle-dot',
    icon: [
      512,
      512,
      [128280,"dot-circle"],
      'f192',
      
      'M480 256A224 224 0 1 0 32 256a224 224 0 1 0 448 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm320 0a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zm-160 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z'
      
    ]
  };

  
    var faDotCircle = faCircleDot;
  

  
  

  var faCompress = {
    prefix: 'fal',
    iconName: 'compress',
    icon: [
      448,
      512,
      [],
      'f066',
      
      'M160 48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 112L16 160c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16l0-128zM16 320c-8.8 0-16 7.2-16 16s7.2 16 16 16l112 0 0 112c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128c0-8.8-7.2-16-16-16L16 320zM320 48c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16l128 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-112 0 0-112zM304 320c-8.8 0-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-112 112 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-128 0z'
      
    ]
  };

  

  
  

  var faArrowRightFromBracket = {
    prefix: 'fal',
    iconName: 'arrow-right-from-bracket',
    icon: [
      512,
      512,
      ["sign-out"],
      'f08b',
      
      'M507.3 267.3c6.2-6.2 6.2-16.4 0-22.6l-128-128c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6L457.4 240 176 240c-8.8 0-16 7.2-16 16s7.2 16 16 16l281.4 0L356.7 372.7c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l128-128zM176 64c8.8 0 16-7.2 16-16s-7.2-16-16-16L80 32C35.8 32 0 67.8 0 112L0 400c0 44.2 35.8 80 80 80l96 0c8.8 0 16-7.2 16-16s-7.2-16-16-16l-96 0c-26.5 0-48-21.5-48-48l0-288c0-26.5 21.5-48 48-48l96 0z'
      
    ]
  };

  
    var faSignOut = faArrowRightFromBracket;
  

  
  

  var faCircleExclamation = {
    prefix: 'fal',
    iconName: 'circle-exclamation',
    icon: [
      512,
      512,
      ["exclamation-circle"],
      'f06a',
      
      'M256 32a224 224 0 1 1 0 448 224 224 0 1 1 0-448zm0 480A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c-8.8 0-16 7.2-16 16l0 128c0 8.8 7.2 16 16 16s16-7.2 16-16l0-128c0-8.8-7.2-16-16-16zm24 224a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'
      
    ]
  };

  
    var faExclamationCircle = faCircleExclamation;
  

  
  

  var faCassetteTape = {
    prefix: 'fal',
    iconName: 'cassette-tape',
    icon: [
      576,
      512,
      [128429],
      'f8ab',
      
      'M512 64c17.7 0 32 14.3 32 32l0 320c0 17.7-14.3 32-32 32l-33.9 0-23.4-64.4c-6.9-19-24.9-31.6-45.1-31.6l-243.2 0c-20.2 0-38.2 12.6-45.1 31.6L97.9 448 64 448c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l448 0zM444.1 448l-312.1 0 19.4-53.5c2.3-6.3 8.3-10.5 15-10.5l243.2 0c6.7 0 12.7 4.2 15 10.5L444.1 448zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm96 160a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm55.4 64c5.4-9.4 8.6-20.3 8.6-32s-3.1-22.6-8.6-32l145.1 0c-5.4 9.4-8.6 20.3-8.6 32s3.1 22.6 8.6 32l-145.1 0zM160 288l256 0c35.3 0 64-28.7 64-64s-28.7-64-64-64l-256 0c-35.3 0-64 28.7-64 64s28.7 64 64 64zm256-96a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faBars = {
    prefix: 'fal',
    iconName: 'bars',
    icon: [
      448,
      512,
      ["navicon"],
      'f0c9',
      
      'M0 80c0-8.8 7.2-16 16-16l416 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 96C7.2 96 0 88.8 0 80zM0 240c0-8.8 7.2-16 16-16l416 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 256c-8.8 0-16-7.2-16-16zM448 400c0 8.8-7.2 16-16 16L16 416c-8.8 0-16-7.2-16-16s7.2-16 16-16l416 0c8.8 0 16 7.2 16 16z'
      
    ]
  };

  
    var faNavicon = faBars;
  

  
  

  var faSquareMinus = {
    prefix: 'fal',
    iconName: 'square-minus',
    icon: [
      448,
      512,
      [61767,"minus-square"],
      'f146',
      
      'M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM128 240l192 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-192 0c-8.8 0-16-7.2-16-16s7.2-16 16-16z'
      
    ]
  };

  
    var faMinusSquare = faSquareMinus;
  

  
  

  var faTable = {
    prefix: 'fal',
    iconName: 'table',
    icon: [
      512,
      512,
      [],
      'f0ce',
      
      'M64 64C46.3 64 32 78.3 32 96l0 64 448 0 0-64c0-17.7-14.3-32-32-32L64 64zM32 192l0 112 208 0 0-112L32 192zm240 0l0 112 208 0 0-112-208 0zM240 336L32 336l0 80c0 17.7 14.3 32 32 32l176 0 0-112zm32 112l176 0c17.7 0 32-14.3 32-32l0-80-208 0 0 112zM0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96z'
      
    ]
  };

  

  
  

  var faBoxArchive = {
    prefix: 'fal',
    iconName: 'box-archive',
    icon: [
      512,
      512,
      ["archive"],
      'f187',
      
      'M480 64L32 64l0 64 32 0 384 0 32 0 0-64zm0 96l-32 0L64 160l-32 0c-17.7 0-32-14.3-32-32L0 64C0 46.3 14.3 32 32 32l448 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32zM160 240c0-8.8 7.2-16 16-16l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-160 0c-8.8 0-16-7.2-16-16zm288-48l32 0 0 224c0 35.3-28.7 64-64 64L96 480c-35.3 0-64-28.7-64-64l0-224 32 0 0 224c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-224z'
      
    ]
  };

  
    var faArchive = faBoxArchive;
  

  
  

  var faPaste = {
    prefix: 'fal',
    iconName: 'paste',
    icon: [
      512,
      512,
      ["file-clipboard"],
      'f0ea',
      
      'M136.5 51.2C138.7 40.2 148.4 32 160 32s21.3 8.2 23.5 19.2C185 58.6 191.6 64 199.2 64l8.8 0c8.8 0 16 7.2 16 16l0 16L96 96l0-16c0-8.8 7.2-16 16-16l8.8 0c7.6 0 14.2-5.4 15.7-12.8zM160 0c-22.3 0-41.6 13.1-50.6 32L64 32C28.7 32 0 60.7 0 96L0 384c0 35.3 28.7 64 64 64l128 0 0-32L64 416c-17.7 0-32-14.3-32-32L32 96c0-17.7 14.3-32 32-32l2.7 0C65 69 64 74.4 64 80l0 16c0 17.7 14.3 32 32 32l112 0c11.5-15.4 28.5-26.4 48-30.4c0-.5 0-1.1 0-1.6l0-16c0-5.6-1-11-2.7-16l2.7 0c17.7 0 32 14.3 32 32l32 0c0-35.3-28.7-64-64-64l-45.4 0c-9-18.9-28.3-32-50.6-32zM448 480l-160 0c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l108.1 0c4.2 0 8.3 1.7 11.3 4.7l67.9 67.9c3 3 4.7 7.1 4.7 11.3L480 448c0 17.7-14.3 32-32 32zm49.9-270.1l-67.9-67.9c-9-9-21.2-14.1-33.9-14.1L288 128c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64l160 0c35.3 0 64-28.7 64-64l0-204.1c0-12.7-5.1-24.9-14.1-33.9z'
      
    ]
  };

  
    var faFileClipboard = faPaste;
  

  
  

  var faSigma = {
    prefix: 'fal',
    iconName: 'sigma',
    icon: [
      384,
      512,
      [8721],
      'f68b',
      
      'M1.3 41.6C3.9 35.8 9.6 32 16 32l328 0c22.1 0 40 17.9 40 40l0 72c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-72c0-4.4-3.6-8-8-8L52.5 64 219.8 245.1c5.7 6.1 5.7 15.6 0 21.7L52.5 448 344 448c4.4 0 8-3.6 8-8l0-72c0-8.8 7.2-16 16-16s16 7.2 16 16l0 72c0 22.1-17.9 40-40 40L16 480c-6.4 0-12.1-3.8-14.7-9.6s-1.4-12.6 2.9-17.3L186.2 256 4.2 58.9C-.1 54.2-1.2 47.4 1.3 41.6z'
      
    ]
  };

  

  
  

  var faAnglesDown = {
    prefix: 'fal',
    iconName: 'angles-down',
    icon: [
      448,
      512,
      ["angle-double-down"],
      'f103',
      
      'M235.3 459.3c-6.2 6.2-16.4 6.2-22.6 0l-160-160c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L224 425.4 372.7 276.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6l-160 160zm160-352l-160 160c-6.2 6.2-16.4 6.2-22.6 0l-160-160c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0L224 233.4 372.7 84.7c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z'
      
    ]
  };

  
    var faAngleDoubleDown = faAnglesDown;
  

  
  

  var faDownLeftAndUpRightToCenter = {
    prefix: 'fal',
    iconName: 'down-left-and-up-right-to-center',
    icon: [
      512,
      512,
      ["compress-alt"],
      'f422',
      
      'M447 256c18.2 0 33-14.8 33-33c0-8.7-3.5-17.1-9.7-23.3L442.6 172l55.7-55.7c15.6-15.6 15.6-40.9 0-56.6L452.3 13.7C436.7-2 411.3-2 395.7 13.7L340 69.4 312.3 41.7C306.1 35.5 297.7 32 289 32c-18.2 0-33 14.8-33 33l0 159c0 17.7 14.3 32 32 32l159 0zm.7-33.7c.2 .2 .3 .4 .3 .7c0 .5-.4 1-1 1l-159 0 0-159c0-.5 .4-1 1-1c.3 0 .5 .1 .7 .3l39 39c6.2 6.2 16.4 6.2 22.6 0l67-67c3.1-3.1 8.2-3.1 11.3 0l46.1 46.1c3.1 3.1 3.1 8.2 0 11.3l-67 67c-3 3-4.7 7.1-4.7 11.3s1.7 8.3 4.7 11.3l39 39zM65 256c-18.2 0-33 14.8-33 33c0 8.7 3.5 17.1 9.7 23.3L69.4 340 13.7 395.7C-2 411.3-2 436.7 13.7 452.3l46.1 46.1c15.6 15.6 40.9 15.6 56.6 0L172 442.6l27.7 27.7c6.2 6.2 14.6 9.7 23.3 9.7c18.2 0 33-14.8 33-33l0-159c0-17.7-14.3-32-32-32L65 256zm-1 33c0-.5 .4-1 1-1l159 0 0 159c0 .5-.4 1-1 1c-.3 0-.5-.1-.7-.3l-39-39c-6.2-6.2-16.4-6.2-22.6 0l-67 67c-3.1 3.1-8.2 3.1-11.3 0L36.3 429.7c-3.1-3.1-3.1-8.2 0-11.3l67-67c3-3 4.7-7.1 4.7-11.3s-1.7-8.3-4.7-11.3l-39-39c-.2-.2-.3-.4-.3-.7z'
      
    ]
  };

  
    var faCompressAlt = faDownLeftAndUpRightToCenter;
  

  
  

  var faAt = {
    prefix: 'fal',
    iconName: 'at',
    icon: [
      512,
      512,
      [61946],
      '40',
      
      'M256 32C132.3 32 32 132.3 32 256s100.3 224 224 224c8.8 0 16 7.2 16 16s-7.2 16-16 16C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256l0 24c0 48.6-39.4 88-88 88c-33.4 0-62.5-18.7-77.4-46.1c-20.4 28-53.4 46.1-90.6 46.1c-61.9 0-112-50.1-112-112s50.1-112 112-112c31.3 0 59.7 12.9 80 33.6l0-1.6c0-8.8 7.2-16 16-16s16 7.2 16 16l0 80 0 24c0 30.9 25.1 56 56 56s56-25.1 56-56l0-24C480 132.3 379.7 32 256 32zm80 224a80 80 0 1 0 -160 0 80 80 0 1 0 160 0z'
      
    ]
  };

  



export {

  faHandshakeSimple,
  
  faHandshakeAlt,
  

  faBuildingColumns,
  
  faBank,
  
  faInstitution,
  
  faMuseum,
  
  faUniversity,
  

  faDollarSign,
  
  faDollar,
  
  faUsd,
  

  faGripDots,
  

  faMagnifyingGlassPlus,
  
  faSearchPlus,
  

  faCircleXmark,
  
  faTimesCircle,
  
  faXmarkCircle,
  

  faArrowsUpDown,
  
  faArrowsV,
  

  faDatabase,
  

  faBriefcase,
  

  faAngleLeft,
  

  faCheck,
  

  faBook,
  

  faTableList,
  
  faThList,
  

  faFunction,
  

  faBorderAll,
  

  faClone,
  

  faCirclePlus,
  
  faPlusCircle,
  

  faCalendar,
  

  faUpRightAndDownLeftFromCenter,
  
  faExpandAlt,
  

  faHashtag,
  

  faClockRotateLeft,
  
  faHistory,
  

  faAnglesLeft,
  
  faAngleDoubleLeft,
  

  faArrowRightToLine,
  
  faArrowToRight,
  

  faPercent,
  
  faPercentage,
  

  faChevronRight,
  

  faChevronLeft,
  

  faAngleUp,
  

  faXmark,
  
  faClose,
  
  faMultiply,
  
  faRemove,
  
  faTimes,
  

  faPlus,
  
  faAdd,
  

  faDiagramProject,
  
  faProjectDiagram,
  

  faListCheck,
  
  faTasks,
  

  faListUl,
  
  faListDots,
  

  faSignalGood,
  
  faSignal3,
  

  faMagnifyingGlass,
  
  faSearch,
  

  faFont,
  

  faLink,
  
  faChain,
  

  faBarsStaggered,
  
  faReorder,
  
  faStream,
  

  faFile,
  

  faBell,
  

  faMessageDots,
  
  faCommentAltDots,
  
  faMessaging,
  

  faEllipsis,
  
  faEllipsisH,
  

  faGripLines,
  

  faAngleDown,
  

  faChartMixed,
  
  faAnalytics,
  

  faFileArrowDown,
  
  faFileDownload,
  

  faUpload,
  

  faArrowUpWideShort,
  
  faSortAmountUp,
  

  faArrowRightArrowLeft,
  
  faExchange,
  

  faHouse,
  
  faHome,
  
  faHomeAlt,
  
  faHomeLgAlt,
  

  faDownload,
  

  faEllipsisVertical,
  
  faEllipsisV,
  

  faFlask,
  

  faSliders,
  
  faSlidersH,
  

  faBallot,
  

  faClock,
  
  faClockFour,
  

  faArrowDownArrowUp,
  
  faSortAlt,
  

  faGear,
  
  faCog,
  

  faMinus,
  
  faSubtract,
  

  faBallPile,
  

  faArrowRotateLeft,
  
  faArrowLeftRotate,
  
  faArrowRotateBack,
  
  faArrowRotateBackward,
  
  faUndo,
  

  faLandmark,
  

  faCircleInfo,
  
  faInfoCircle,
  

  faAnglesUp,
  
  faAngleDoubleUp,
  

  faUserSecret,
  

  faFilePdf,
  

  faTrash,
  

  faArrowRotateRight,
  
  faArrowRightRotate,
  
  faArrowRotateForward,
  
  faRedo,
  

  faFloppyDisk,
  
  faSave,
  

  faPen,
  

  faEye,
  

  faBarsProgress,
  
  faTasksAlt,
  

  faCircleQuestion,
  
  faQuestionCircle,
  

  faRecycle,
  

  faCircle,
  

  faScrewdriverWrench,
  
  faTools,
  

  faArrowRight,
  

  faFileExcel,
  

  faPuzzlePiece,
  

  faFilter,
  

  faListOl,
  
  faList12,
  
  faListNumeric,
  

  faArrowTurnDownRight,
  

  faFileZipper,
  
  faFileArchive,
  

  faBorderOuter,
  

  faLayerGroup,
  

  faArrowsLeftRight,
  
  faArrowsH,
  

  faSquareDollar,
  
  faDollarSquare,
  
  faUsdSquare,
  

  faArrowDownWideShort,
  
  faSortAmountAsc,
  
  faSortAmountDown,
  

  faCloudArrowUp,
  
  faCloudUpload,
  
  faCloudUploadAlt,
  

  faCircleCheck,
  
  faCheckCircle,
  

  faCirclePlay,
  
  faPlayCircle,
  

  faAnglesRight,
  
  faAngleDoubleRight,
  

  faTableColumns,
  
  faColumns,
  

  faSquarePlus,
  
  faPlusSquare,
  

  faChartBar,
  
  faBarChart,
  

  faArrowDownToLine,
  
  faArrowToBottom,
  

  faFileArrowUp,
  
  faFileUpload,
  

  faHouseDay,
  

  faToggleOn,
  

  faLayerPlus,
  
  faLayerGroupPlus,
  

  faUserGroup,
  
  faUserFriends,
  

  faArrowRightToBracket,
  
  faSignIn,
  

  faChartArea,
  
  faAreaChart,
  

  faLocationArrow,
  

  faMessagePlus,
  
  faCommentAltPlus,
  

  faUser,
  

  faFolder,
  
  faFolderBlank,
  

  faArrowLeftToLine,
  
  faArrowToLeft,
  

  faAngleRight,
  

  faPenToSquare,
  
  faEdit,
  

  faLock,
  

  faCircleDot,
  
  faDotCircle,
  

  faCompress,
  

  faArrowRightFromBracket,
  
  faSignOut,
  

  faCircleExclamation,
  
  faExclamationCircle,
  

  faCassetteTape,
  

  faBars,
  
  faNavicon,
  

  faSquareMinus,
  
  faMinusSquare,
  

  faTable,
  

  faBoxArchive,
  
  faArchive,
  

  faPaste,
  
  faFileClipboard,
  

  faSigma,
  

  faAnglesDown,
  
  faAngleDoubleDown,
  

  faDownLeftAndUpRightToCenter,
  
  faCompressAlt,
  

  faAt,
  

};
